import React, { useState, useEffect, useCallback } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  StyleSheet,

  StatusBar,
  Alert,
  RefreshControl,
  Image,
  Dimensions,
  Modal,
  FlatList,
  Animated,
  TextInput,
  KeyboardAvoidingView,
  Platform,
  Linking,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { LinearGradient } from 'expo-linear-gradient';
import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Print from 'expo-print';
import * as Sharing from 'expo-sharing';
import { useAuth } from '../../../context/AuthContext';
import { useFocusEffect } from '@react-navigation/native';
import { DashAPI, PayrollIntegrationAPI } from '../../../services/employeeApi';

const { width, height } = Dimensions.get('window');

export default function EmployeeDashboard({ navigation, route }) {
  const { user: authUser, logout } = useAuth();
  // If navigated from EmployeeManagement, use the passed employee; otherwise use logged-in user
  const routeEmployee = route?.params?.employee || null;
  const user = routeEmployee
    ? {
        ...routeEmployee,
        id:              routeEmployee.serverId || routeEmployee.id,
        employeeId:      routeEmployee.serverId || routeEmployee.id,
        employeeNumber:  routeEmployee.employeeNumber || routeEmployee.employeeId || '',
        email:       routeEmployee.email,
        full_name:   routeEmployee.name,
        name:        routeEmployee.name,
        avatar:      routeEmployee.avatar,
        department:  routeEmployee.department,
        position:    routeEmployee.position || routeEmployee.jobTitle,
      }
    : authUser;
  const [refreshing, setRefreshing] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isCheckedIn, setIsCheckedIn] = useState(false);
  const [workHours, setWorkHours] = useState({ today: 0, week: 0, month: 0 });
  const [tasks, setTasks] = useState([]);
  const [projects, setProjects] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);
  const [dashboardStats, setDashboardStats] = useState({
    activeTasks: 0,
    completedTasks: 0,
    activeProjects: 0,
    pendingApprovals: 0,
  });
  const [fadeAnim] = useState(new Animated.Value(0));
  const [payrollSummary, setPayrollSummary] = useState({
    nextPayDate: '',
    nextPayAmount: 0,
    lastNetPay: 0,
    lastGrossPay: 0,
    lastPayDate: '',
    ytdGross: 0,
    ytdTax: 0,
    ytdNI: 0,
    ytdPension: 0,
    ytdNet: 0,
    taxCode: '1257L',
    niCategory: 'A',
    payslips: [],
  });
  const [showPayslipsModal, setShowPayslipsModal] = useState(false);
  const [showPayslipDetail, setShowPayslipDetail] = useState(false);
  // Extended feature state
  const [teamMembers,      setTeamMembers]      = useState([]);
  const [announcements,    setAnnouncements]    = useState([]);
  const [leaveBalance,     setLeaveBalance]     = useState({ annual:25, sick:10, used:0, pending:0 });
  const [employeeName,     setEmployeeName]     = useState('');
  const [employeeRole,     setEmployeeRole]     = useState('');
  const [employeeDept,     setEmployeeDept]     = useState('');
  const [employeeAvatar,   setEmployeeAvatar]   = useState(null);
  const [upcomingEvents,   setUpcomingEvents]   = useState([]);
  const [personalGoals,    setPersonalGoals]    = useState([]);
  const [trainingModules,  setTrainingModules]  = useState([]);
  const [myAttendance,     setMyAttendance]     = useState({ present:0, absent:0, late:0, rate:0 });
  const [benefits,         setBenefits]         = useState([]);
  const [showLeaveModal,   setShowLeaveModal]   = useState(false);
  const [showGoalModal,    setShowGoalModal]    = useState(false);
  const [showTeamModal,    setShowTeamModal]    = useState(false);
  const [showAnnounceModal,setShowAnnounceModal]= useState(false);
  const [leaveType,        setLeaveType]        = useState('Annual');
  const [leaveDays,        setLeaveDays]        = useState('');
  const [leaveNote,        setLeaveNote]        = useState('');
  const [newGoalTitle,     setNewGoalTitle]     = useState('');
  const [newGoalTarget,    setNewGoalTarget]    = useState('');
  const [showMoodModal,    setShowMoodModal]    = useState(false);
  const [todayMood,        setTodayMood]        = useState(null);
  const [taskFilter,       setTaskFilter]       = useState('all');
  const [selectedPayslip, setSelectedPayslip] = useState(null);
  const [payrollExtended, setPayrollExtended] = useState({
    salary: 0, payFrequency: 'Monthly', paymentMethod: 'BACS',
    bankName: '', bankAccount: '', bankSortCode: '',
    bonus: 0, overtime: 0, allowances: 0, commission: 0,
    studentLoanPlan: '', pensionScheme: '', pensionContribRate: 5,
    employerPensionRate: 3, p60Available: false,
    contractType: 'Full-time', hoursPerWeek: 37.5,
  });
  const [showPayrollFullModal, setShowPayrollFullModal] = useState(false);
  const [payslipPdfLoading, setPayslipPdfLoading] = useState(false);


  // Show back button when navigated from another screen
  const canGoBack = route?.params?.employee != null;

  // Reload check-in state when returning from AttendanceScreen
  useFocusEffect(
    useCallback(() => {
      const reloadAttendance = async () => {
        try {
          const checkedIn = await AsyncStorage.getItem('employee_checked_in');
          if (checkedIn !== null) setIsCheckedIn(checkedIn === 'true');
          const storedHours = await AsyncStorage.getItem('employee_work_hours');
          if (storedHours) setWorkHours(JSON.parse(storedHours));
        } catch {}
      };
      reloadAttendance();
    }, [])
  );

  useEffect(() => {
    initializeDashboard();
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    
    // Animate content on load
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 800,
      useNativeDriver: true,
    }).start();

    return () => clearInterval(timer);
  }, []);


  const loadPayrollData = async () => {
    try {
      const userId = user?.id || user?.serverId || user?.employeeId || user?.email || 'default';

      // ── Try real API first ────────────────────────────────────────────────
      let apiPayroll = null;
      let apiPayslips = [];
      let apiYtd = {};
      try {
        // Real: GET /api/payroll/employee/{userId}/summary
        const _pb = 'https://api.jobeng.ai';
        const _pk = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
        const _pt = await AsyncStorage.getItem('auth_token') || await AsyncStorage.getItem('token');
        const _ph = { 'x-api-key': _pk, ...(_pt ? { Authorization: `Bearer ${_pt}` } : {}) };
        const _sr = await fetch(`${_pb}/api/payroll/employee/${String(userId)}/summary`, { headers: _ph });
        if (_sr.ok) {
          const s = await _sr.json();
          const d = s.data ?? s;
          apiPayroll  = d.payroll ?? d.employee ?? d ?? null;
          apiPayslips = d.payslips ?? [];
          apiYtd      = d.ytd ?? d.yearToDate ?? {};
        } else {
          const [pr, psr, yr] = await Promise.allSettled([
            PayrollIntegrationAPI.getEmployee(userId),
            PayrollIntegrationAPI.getPayslips(userId),
            PayrollIntegrationAPI.getYtd(userId),
          ]);
          if (pr.status  === 'fulfilled') apiPayroll  = pr.value?.data  ?? null;
          if (psr.status === 'fulfilled') apiPayslips = psr.value?.data ?? [];
          if (yr.status  === 'fulfilled') apiYtd      = yr.value?.data  ?? {};
        }
      } catch (_) { /* API failed — will fall through to fallbacks */ }

      // ── Additional: fetch employee payroll record for salary/bank details ──
      try {
        const _pb = 'https://api.jobeng.ai';
        const _pk = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';
        const _pt = await AsyncStorage.getItem('auth_token') || await AsyncStorage.getItem('token');
        const _ph = { 'x-api-key': _pk, ...(_pt ? { Authorization: `Bearer ${_pt}` } : {}) };
        const cid = await AsyncStorage.getItem('company_id') || await AsyncStorage.getItem('company_id');
        
        // Try payroll_employees table
        const peRes = await fetch(`${_pb}/api/data/payroll_employees?employee_id=${String(userId)}${cid ? '&company_id=' + cid : ''}`, { headers: _ph });
        if (peRes.ok) {
          const peData = await peRes.json();
          const pe = Array.isArray(peData.data) ? peData.data[0] : (peData.data || null);
          if (pe) {
            setPayrollExtended(prev => ({
              ...prev,
              salary: parseFloat(pe.annual_salary || pe.salary || pe.basic_salary || 0),
              payFrequency: pe.pay_frequency || pe.payFrequency || 'Monthly',
              paymentMethod: pe.payment_method || pe.paymentMethod || 'BACS',
              bankName: pe.bank_name || pe.bankName || '',
              bankAccount: pe.bank_account || pe.bankAccount || '',
              bankSortCode: pe.bank_sort_code || pe.bankSortCode || '',
              bonus: parseFloat(pe.bonus || 0),
              overtime: parseFloat(pe.overtime_pay || pe.overtime || 0),
              allowances: parseFloat(pe.allowances || pe.travel_allowance || 0),
              commission: parseFloat(pe.commission || 0),
              studentLoanPlan: pe.student_loan_plan || pe.studentLoanPlan || '',
              pensionScheme: pe.pension_scheme || pe.pensionScheme || '',
              pensionContribRate: parseFloat(pe.pension_rate || pe.employee_pension_rate || 5),
              employerPensionRate: parseFloat(pe.employer_pension_rate || 3),
              contractType: pe.contract_type || pe.contractType || 'Full-time',
              hoursPerWeek: parseFloat(pe.hours_per_week || pe.hoursPerWeek || 37.5),
              p60Available: !!pe.p60_available,
            }));
            // Cache
            await AsyncStorage.setItem(`payroll_ext_${userId}`, JSON.stringify(pe));
            // Personal payroll cache — only this user's data
            await AsyncStorage.setItem(`my_payroll_${userId}`, JSON.stringify(pe));
          }
        }

        // Also try employees table for salary
        if (!payrollExtended.salary) {
          const empRes = await fetch(`${_pb}/api/employees/${String(userId)}`, { headers: _ph });
          if (empRes.ok) {
            const empData = await empRes.json();
            const emp = empData.data || empData;
            if (emp?.salary || emp?.annual_salary) {
              setPayrollExtended(prev => ({
                ...prev,
                salary: parseFloat(emp.annual_salary || emp.salary || 0),
                contractType: emp.contract_type || emp.employment_type || prev.contractType,
              }));
            }
          }
        }
      } catch (extErr) { console.warn('Extended payroll fetch:', extErr?.message); }

      // ── AsyncStorage fallback for extended data ──
      try {
        const extRaw = await AsyncStorage.getItem(`payroll_ext_${userId}`);
        if (extRaw) {
          const ext = JSON.parse(extRaw);
          setPayrollExtended(prev => ({ ...prev, ...ext }));
        }
      } catch {}

      if (apiPayroll) {
        const sortedSlips = [...(Array.isArray(apiPayslips) ? apiPayslips : [])].sort(
          (a, b) => new Date(b.period || b.date || 0) - new Date(a.period || a.date || 0)
        );
        const lastSlip = sortedSlips[0] || null;
        const today = new Date();
        const payDay = apiPayroll.paymentDay || apiPayroll.paymentDate || 28;
        let nextPay = new Date(today.getFullYear(), today.getMonth(), payDay);
        if (nextPay <= today) nextPay = new Date(today.getFullYear(), today.getMonth() + 1, payDay);

        const personalPayslips = sortedSlips.slice(0, 12);
        setPayrollSummary({
          nextPayDate:  nextPay.toISOString(),
          nextPayAmount: apiPayroll.monthlyNet || 0,
          lastNetPay:   lastSlip?.net   || lastSlip?.netPay   || 0,
          lastGrossPay: lastSlip?.gross || lastSlip?.grossPay || 0,
          lastPayDate:  lastSlip?.period || lastSlip?.date || '',
          ytdGross:     apiYtd.gross   ?? 0,
          ytdTax:       apiYtd.tax     ?? 0,
          ytdNI:        apiYtd.ni      ?? 0,
          ytdPension:   apiYtd.pension ?? 0,
          ytdNet:       apiYtd.net     ?? 0,
          taxCode:      apiPayroll.taxCode    || '1257L',
          niCategory:   apiPayroll.niCategory || 'A',
          payslips:     personalPayslips,
        });
        // Cache personal payslips under user-specific key
        try { await AsyncStorage.setItem(`my_payslips_${userId}`, JSON.stringify(personalPayslips)); } catch {}
        return; // done
      }

      // ── AsyncStorage fallback (offline / personal data only) ────────────────
      
      // PERSONAL: Only load this user's own payroll data — never bulk data
      const myUserId = userId;
      const myEmail = user?.email || '';
      const myName = user?.name || user?.full_name || '';

      // 1. User-specific payroll record
      const myPayrollRecord = (() => {
        try {
          const raw = AsyncStorage.getItem('payroll_records_per_employee');
          if (!raw) return null;
          const records = JSON.parse(raw);
          return records[myUserId] || null;
        } catch { return null; }
      })();

      // 2. Filter payslips — ONLY this employee's (match by ID, email, or name)
      let myPayslips = [];
      try {
        // Prefer user-specific key first
        const personalRaw = await AsyncStorage.getItem(`my_payslips_${myUserId}`);
        if (personalRaw) {
          myPayslips = JSON.parse(personalRaw);
        } else {
          // Fallback: filter from shared pool (read-only, never expose others)
          const allRaw = await AsyncStorage.getItem('payroll_payslips');
          if (allRaw) {
            const all = JSON.parse(allRaw);
            myPayslips = all.filter(p =>
              String(p.employeeId) === String(myUserId) ||
              (myEmail && p.employeeEmail?.toLowerCase() === myEmail.toLowerCase()) ||
              (myName && p.employeeName === myName)
            );
            // Cache personal payslips separately for next time
            if (myPayslips.length > 0) {
              await AsyncStorage.setItem(`my_payslips_${myUserId}`, JSON.stringify(myPayslips));
            }
          }
        }
      } catch {}

      // 3. User-specific sync data
      let mySync = null;
      try {
        const syncRaw = await AsyncStorage.getItem('payroll_employee_sync');
        if (syncRaw) {
          const syncData = JSON.parse(syncRaw);
          mySync = syncData[myUserId] || (myEmail ? syncData[myEmail] : null) || null;
        }
      } catch {}

      // Calculate YTD from payslips
      const currentYear = new Date().getFullYear();
      const ytdPayslips = myPayslips.filter(p => new Date(p.period || p.date || 0).getFullYear() === currentYear);
      const ytdGross = ytdPayslips.reduce((s, p) => s + (p.gross || p.grossPay || 0), 0);
      const ytdTax = ytdPayslips.reduce((s, p) => s + (p.tax || p.incomeTax || 0), 0);
      const ytdNI = ytdPayslips.reduce((s, p) => s + (p.ni || p.nationalInsurance || 0), 0);
      const ytdPension = ytdPayslips.reduce((s, p) => s + (p.employeePension || p.pension || 0), 0);
      const ytdNet = ytdPayslips.reduce((s, p) => s + (p.net || p.netPay || 0), 0);

      // Last payslip
      const sortedPayslips = [...myPayslips].sort((a, b) => new Date(b.period || b.date || 0) - new Date(a.period || a.date || 0));
      const lastPayslip = sortedPayslips[0] || null;

      // Next pay date calculation
      const today = new Date();
      const payDay = mySync?.paymentDate || myPayrollRecord?.paymentDate || 28;
      let nextPay = new Date(today.getFullYear(), today.getMonth(), payDay);
      if (nextPay <= today) {
        nextPay = new Date(today.getFullYear(), today.getMonth() + 1, payDay);
      }

      setPayrollSummary({
        nextPayDate: nextPay.toISOString(),
        nextPayAmount: mySync?.salary ? Math.round((mySync.salary / 12) * 0.75) : 0,
        lastNetPay: lastPayslip?.net || lastPayslip?.netPay || 0,
        lastGrossPay: lastPayslip?.gross || lastPayslip?.grossPay || 0,
        lastPayDate: lastPayslip?.period || lastPayslip?.date || '',
        ytdGross,
        ytdTax,
        ytdNI,
        ytdPension,
        ytdNet,
        taxCode: mySync?.taxCode || myPayrollRecord?.taxCode || '1257L',
        niCategory: mySync?.niCategory || myPayrollRecord?.niCategory || 'A',
        payslips: sortedPayslips.slice(0, 12),
      });

      // Add payroll notifications
      if (lastPayslip && !myPayslips.find(p => p._dashNotified)) {
        const payrollNotif = {
          id: Date.now(),
          title: 'Payslip Available',
          message: `Your payslip for ${formatPayPeriod(lastPayslip?.period || lastPayslip?.date)} is ready`,
          time: 'Just now',
          type: 'payroll',
          read: false,
          action: 'view_payslips',
        };
        setNotifications(prev => {
          const alreadyExists = prev.find(n => n.type === 'payroll' && n.title === 'Payslip Available');
          if (alreadyExists) return prev;
          return [payrollNotif, ...prev];
        });
      }
    } catch (err) {
      console.error('Error loading payroll data:', err);
    }
  };

  const formatPayPeriod = (dateStr) => {
    if (!dateStr) return 'recent period';
    const d = new Date(dateStr);
    return d.toLocaleDateString('en-GB', { month: 'long', year: 'numeric' });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount || 0);
  };

  const initializeDashboard = async () => {
    try {
      await loadDashboardData();
      await checkWorkStatus();
      await loadWorkHours();
      await loadPayrollData();
    await loadExtendedData();
    } catch (error) {
      console.error('Error initializing dashboard:', error);
      Alert.alert('Error', 'Failed to load dashboard data');
    }
  };

  // ── Rich employee dashboard from payroll routes ─────────────────────────────
  const fetchEmployeeDashboard = async (rawEmpId) => {
    const empId = String(rawEmpId);
    const token = await AsyncStorage.getItem('auth_token') || await AsyncStorage.getItem('token');
    const hdrs = {
      'Content-Type': 'application/json',
      'x-api-key': '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    };
    const base = 'https://api.jobeng.ai';
    // ── Fetch employee data from multiple real endpoints ──
    let d = {};

    // 1. Try /api/employees/:id (exact ID match)
    try {
      const empRes = await fetch(`${base}/api/employees/${empId}`, { headers: hdrs });
      if (empRes.ok) {
        const empJson = await empRes.json();
        d = empJson?.data || empJson || {};
      }
    } catch {}

    // 2. If not found, try /api/data/employees?id=empId
    if (!d.id) {
      try {
        const empRes2 = await fetch(`${base}/api/data/employees?id=${empId}`, { headers: hdrs });
        if (empRes2.ok) {
          const empJson2 = await empRes2.json();
          const arr = empJson2?.data || [];
          if (Array.isArray(arr) && arr.length > 0) d = arr[0];
        }
      } catch {}
    }

    // 3. If still not found, try by email
    if (!d.id) {
      const userEmail = user?.email || await AsyncStorage.getItem('user_email');
      if (userEmail) {
        try {
          const emailRes = await fetch(`${base}/api/data/employees?email=${encodeURIComponent(userEmail)}`, { headers: hdrs });
          if (emailRes.ok) {
            const emailJson = await emailRes.json();
            const arr = emailJson?.data || [];
            if (Array.isArray(arr) && arr.length > 0) d = arr[0];
          }
        } catch {}
      }
    }

    if (!d.id) throw new Error('Employee not found');
    // Map rich payroll response to dashboard state shape
    return {
      employee: {
        id: d.id, name: d.full_name, email: d.email, phone: d.phone,
        department: d.department, position: d.position,
        salary: parseFloat(d.annual_salary || 0),
        status: d.status,
      },
      payroll: {
        nextPayDate:    d.next_pay_date,
        nextPayAmount:  parseFloat(d.monthly_salary || 0),
        ytd: { gross: parseFloat(d.ytd_gross||0), tax: parseFloat(d.ytd_tax||0), ni: parseFloat(d.ytd_ni||0), pension: parseFloat(d.ytd_pension||0), net: parseFloat(d.ytd_net||0) },
      },
      payslips: d.payslips || [],
      latestPayslip: d.latest_payslip || null,
      leaveBalance: {
        annual:    parseInt(d.annual_leave_total || 25),
        used:      parseInt(d.leave_used || 0),
        remaining: parseInt(d.leave_remaining || 25),
        sick:      parseInt(d.sick_leave_total || 10),
      },
      pendingLeave: parseInt(d.pending_leave || 0),
      leaveHistory: d.leave_history || [],
      goals: d.all_goals || d.active_goals || [],
      warnings: d.active_warnings || [],
      warningCount: parseInt(d.warning_count || 0),
      pension: d.pension_details || {},
      bankDetails: d.bank_details || {},
      attendance: {
        hoursToday: parseFloat(d.hours_today || 0),
        hoursWeek:  parseFloat(d.hours_week  || 0),
        hoursMonth: parseFloat(d.hours_month || 0),
        checkedIn:  d.check_in_status === 'checked-in',
      },
    };
  };

  const loadDashboardData = async () => {
    try {
      // ── Resolve employee ID ────────────────────────────────────────────────
      const storedProfId  = await AsyncStorage.getItem('professional_id');
      const storedEmpId   = await AsyncStorage.getItem('employee_id');
      const storedEmpNum  = await AsyncStorage.getItem('employee_number'); // e.g. EMP001
      const routeEmp = route?.params?.employee;

      let empId;
      if (routeEmp) {
        // Navigated from another screen — server DB id is always primary
        empId = routeEmp.serverId          // integer from DB (preferred)
             || routeEmp.id                // might already be server id
             || routeEmp.employeeId        // fallback
             || routeEmp.employee_number   // display code like EMP001
             || '1';
      } else {
        // Logged-in employee viewing their own dashboard
        empId = storedEmpId    // server id stored at login
             || storedProfId
             || storedEmpNum   // EMP001 format (last resort)
             || user?.id
             || user?.employeeId
             || '1';
      }
      // Always stringify — endpoint accepts both string and integer
      empId = String(empId);

      // ── Hit the real endpoint ──────────────────────────────────────────────
      let apiData = null;
      try {
        apiData = await fetchEmployeeDashboard(empId);
        await AsyncStorage.setItem('employee_dashboard_cache', JSON.stringify({ data: apiData, ts: Date.now() }));
        console.log('[EmpDash] Loaded dashboard for employee:', empId);
        
        // Apply rich data to state
        if (apiData.payroll) {
          setPayrollSummary(prev => ({
            ...prev,
            nextPayDate:   apiData.payroll.nextPayDate   || prev.nextPayDate,
            nextPayAmount: apiData.payroll.nextPayAmount || prev.nextPayAmount,
            ytdGross:      apiData.payroll.ytd?.gross    || prev.ytdGross,
            ytdTax:        apiData.payroll.ytd?.tax      || prev.ytdTax,
            ytdNI:         apiData.payroll.ytd?.ni       || prev.ytdNI,
            ytdPension:    apiData.payroll.ytd?.pension  || prev.ytdPension,
            ytdNet:        apiData.payroll.ytd?.net      || prev.ytdNet,
          }));
        }
        if (apiData.payslips?.length > 0) setPayslips(apiData.payslips);
        if (apiData.goals?.length > 0) setTasks(apiData.goals.map(g => ({
          id: g.id, title: g.title, progress: g.progress,
          dueDate: g.due_date, status: g.status,
        })));
        if (apiData.leaveBalance) setLeaveBalance(apiData.leaveBalance);
        if (apiData.attendance) {
          setWorkHours({
            today: apiData.attendance.hoursToday,
            week:  apiData.attendance.hoursWeek,
            month: apiData.attendance.hoursMonth,
          });
          setIsCheckedIn(apiData.attendance.checkedIn);
        }
      } catch (apiErr) {
        console.warn('[EmpDash] API failed, using cache:', apiErr.message);
        const cached = await AsyncStorage.getItem('employee_dashboard_cache');
        if (cached) {
          const { data } = JSON.parse(cached);
          apiData = data;
        }
      }

      if (apiData) {
        // ── Map API response to component state ──────────────────────────────
        // The API returns a rich object — extract each section safely
        const emp   = apiData.employee   ?? apiData.profile ?? {};
        const stats = apiData.stats      ?? apiData.overview ?? apiData.dashboard ?? {};
        const tasks  = apiData.tasks     ?? apiData.activeTasks    ?? [];
        const projs  = apiData.projects  ?? apiData.activeProjects  ?? [];
        const notifs = apiData.notifications ?? apiData.alerts      ?? [];
        const leave  = apiData.leaveBalance  ?? apiData.leave       ?? {};
        const payroll= apiData.payroll       ?? apiData.compensation ?? {};
        const attend = apiData.attendance    ?? {};
        const goals  = apiData.goals         ?? [];
        const training = apiData.training    ?? apiData.trainingModules ?? [];
        const benefits = apiData.benefits    ?? [];

        // Stats
        setDashboardStats({
          activeTasks:      (Array.isArray(tasks) ? tasks.filter(t => t.status !== 'completed').length : stats.activeTasks)     ?? 0,
          completedTasks:   (Array.isArray(tasks) ? tasks.filter(t => t.status === 'completed').length : stats.completedTasks)  ?? 0,
          activeProjects:   (Array.isArray(projs) ? projs.length : stats.activeProjects)   ?? 0,
          pendingApprovals: stats.pendingApprovals ?? 0,
          totalEmployees:   stats.totalEmployees   ?? 0,
          activeEmployees:  stats.activeEmployees  ?? 0,
          onLeave:          stats.onLeave          ?? 0,
          newHires:         stats.newHires         ?? 0,
          warningCount:     stats.warningCount     ?? stats.warnings ?? 0,
          attendanceRate:   attend.rate            ?? stats.attendanceRate ?? 95,
          currentSalary:    payroll.salary         ?? payroll.baseSalary   ?? 0,
          nextPayDate:      payroll.nextPayDate     ?? payroll.nextPayment  ?? '',
        });

        // Employee profile fields
        if (emp.name || emp.firstName) {
          const fullName = emp.name ?? `${emp.firstName ?? ''} ${emp.lastName ?? ''}`.trim();
          setEmployeeName(fullName);
          setEmployeeRole(emp.position ?? emp.jobTitle ?? emp.role ?? '');
          setEmployeeDept(emp.department ?? '');
          if (emp.avatar ?? emp.profileImage ?? emp.profile_image) {
            setEmployeeAvatar(emp.avatar ?? emp.profileImage ?? emp.profile_image);
          }
        }

        // Tasks
        if (Array.isArray(tasks) && tasks.length > 0) {
          setTasks(tasks.map(t => ({
            id:             t.id,
            title:          t.title         ?? t.name        ?? t.description ?? '',
            project:        t.project       ?? t.projectName ?? '',
            priority:       t.priority      ?? 'medium',
            dueDate:        t.dueDate       ?? t.due_date    ?? t.deadline    ?? '',
            status:         t.status        ?? 'pending',
            progress:       t.progress      ?? t.completion  ?? 0,
            estimatedHours: t.estimatedHours ?? t.estimated_hours ?? 0,
            actualHours:    t.actualHours   ?? t.actual_hours ?? 0,
          })));
        }

        // Projects
        if (Array.isArray(projs) && projs.length > 0) {
          setProjects(projs.map(p => ({
            id:          p.id,
            name:        p.name       ?? p.title     ?? '',
            role:        p.role       ?? p.userRole  ?? 'Member',
            progress:    p.progress   ?? p.completion ?? 0,
            status:      p.status     ?? 'active',
            dueDate:     p.dueDate    ?? p.due_date  ?? p.endDate ?? '',
            teamSize:    p.teamSize   ?? p.team_size ?? (Array.isArray(p.members) ? p.members.length : 0),
            priority:    p.priority   ?? 'medium',
          })));
        }

        // Notifications
        if (Array.isArray(notifs) && notifs.length > 0) {
          setNotifications(notifs.map(n => ({
            id:      n.id,
            title:   n.title   ?? n.subject ?? 'Notification',
            message: n.message ?? n.body    ?? n.content ?? '',
            time:    n.time    ?? (n.createdAt ? new Date(n.createdAt).toLocaleTimeString() : ''),
            type:    n.type    ?? 'info',
            read:    n.read    ?? false,
          })));
        }

        // Leave balance
        if (leave && (leave.annual !== undefined || leave.sick !== undefined || leave.remaining !== undefined)) {
          setLeaveBalance({
            annual:   leave.annual   ?? leave.annualLeave   ?? 25,
            sick:     leave.sick     ?? leave.sickLeave     ?? 10,
            personal: leave.personal ?? leave.personalLeave ?? 5,
            used:     leave.used     ?? leave.usedDays      ?? 0,
            pending:  leave.pending  ?? leave.pendingDays   ?? 0,
            remaining:leave.remaining ?? leave.remainingDays ?? 25,
          });
        }

        // Goals
        if (Array.isArray(goals) && goals.length > 0) setPersonalGoals(goals);

        // Training
        if (Array.isArray(training) && training.length > 0) setTrainingModules(training);

        // Benefits
        if (Array.isArray(benefits) && benefits.length > 0) setBenefits(benefits);

        // Attendance
        if (attend.todayHours ?? attend.today) {
          setWorkHours({
            today: attend.todayHours ?? attend.today ?? 0,
            week:  attend.weekHours  ?? attend.week  ?? 0,
            month: attend.monthHours ?? attend.month ?? 0,
          });
        }

        return; // Successfully loaded from API
      }

      // ── Full fallback to AsyncStorage / mock ──────────────────────────────
      const storedData = await AsyncStorage.getItem('employee_dashboard_data');
      if (storedData) {
        const parsed = JSON.parse(storedData);
        setTasks(parsed.tasks   || []);
        setProjects(parsed.projects || []);
        setNotifications(parsed.notifications || []);
        setDashboardStats(parsed.stats || { activeTasks: 0, completedTasks: 0, activeProjects: 0, pendingApprovals: 0 });
      } else {
        await loadMockData();
      }

    } catch (error) {
      console.error('Error loading dashboard data:', error);
      try {
        const storedData = await AsyncStorage.getItem('employee_dashboard_data');
        if (storedData) {
          const parsed = JSON.parse(storedData);
          setTasks(parsed.tasks   || []);
          setProjects(parsed.projects || []);
          setNotifications(parsed.notifications || []);
          setDashboardStats(parsed.stats || { activeTasks: 0, completedTasks: 0, activeProjects: 0, pendingApprovals: 0 });
        } else {
          await loadMockData();
        }
      } catch (_) {
        await loadMockData();
      }
    }
  };

  const loadMockData = async () => {
    const mockTasks = [
      {
        id: 1,
        title: 'Site Safety Inspection',
        project: 'Downtown Office Complex',
        priority: 'high',
        dueDate: '2024-01-15',
        status: 'in_progress',
        progress: 75,
        estimatedHours: 4,
        actualHours: 3,
      },
      {
        id: 2,
        title: 'Equipment Maintenance Check',
        project: 'Residential Tower A',
        priority: 'medium',
        dueDate: '2024-01-16',
        status: 'pending',
        progress: 0,
        estimatedHours: 2,
        actualHours: 0,
      },
      {
        id: 3,
        title: 'Quality Control Report',
        project: 'Bridge Construction',
        priority: 'high',
        dueDate: '2024-01-14',
        status: 'completed',
        progress: 100,
        estimatedHours: 6,
        actualHours: 5.5,
      },
      {
        id: 4,
        title: 'Material Inventory Update',
        project: 'Shopping Mall Phase 2',
        priority: 'low',
        dueDate: '2024-01-18',
        status: 'pending',
        progress: 25,
        estimatedHours: 3,
        actualHours: 0.75,
      },
    ];

    const mockProjects = [
      {
        id: 1,
        name: 'Downtown Office Complex',
        status: 'active',
        progress: 68,
        role: 'Site Supervisor',
        deadline: '2024-03-15',
        team: 12,
        budget: 2500000,
        spent: 1680000,
      },
      {
        id: 2,
        name: 'Residential Tower A',
        status: 'active',
        progress: 45,
        role: 'Safety Officer',
        deadline: '2024-05-20',
        team: 8,
        budget: 1800000,
        spent: 810000,
      },
      {
        id: 3,
        name: 'Bridge Construction',
        status: 'completed',
        progress: 100,
        role: 'Quality Inspector',
        deadline: '2024-01-10',
        team: 15,
        budget: 3200000,
        spent: 3040000,
      },
    ];

    const mockNotifications = [
      {
        id: 1,
        title: 'New Task Assigned',
        message: 'You have been assigned to Site Safety Inspection',
        time: '10 minutes ago',
        type: 'task',
        read: false,
        action: 'view_task',
        actionParams: { taskId: 1 },
      },
      {
        id: 2,
        title: 'Meeting Reminder',
        message: 'Project review meeting at 2:00 PM today',
        time: '1 hour ago',
        type: 'meeting',
        read: false,
        action: 'view_calendar',
      },
      {
        id: 3,
        title: 'Timesheet Approved',
        message: 'Your timesheet for last week has been approved',
        time: '2 hours ago',
        type: 'approval',
        read: true,
        action: 'view_timesheet',
      },
    ];

    setTasks(mockTasks);
    setProjects(mockProjects);
    setNotifications(mockNotifications);

    // Calculate dashboard stats
    const activeTasks = mockTasks.filter(task => task.status === 'in_progress' || task.status === 'pending').length;
    const completedTasks = mockTasks.filter(task => task.status === 'completed').length;
    const activeProjects = mockProjects.filter(project => project.status === 'active').length;
    const pendingApprovals = mockNotifications.filter(notif => notif.type === 'approval' && !notif.read).length;

    const stats = {
      activeTasks,
      completedTasks,
      activeProjects,
      pendingApprovals,
    };

    setDashboardStats(stats);

    // Save to AsyncStorage
    await AsyncStorage.setItem('employee_dashboard_data', JSON.stringify({
      tasks: mockTasks,
      projects: mockProjects,
      notifications: mockNotifications,
      stats,
    }));
  };

  const loadExtendedData = async () => {
    try {
      const stored = await AsyncStorage.getItem('employee_extended_data');
      if (stored) {
        const d = JSON.parse(stored);
        if (d.teamMembers)     setTeamMembers(d.teamMembers);
        if (d.announcements)   setAnnouncements(d.announcements);
        if (d.leaveBalance)    setLeaveBalance(d.leaveBalance);
        if (d.upcomingEvents)  setUpcomingEvents(d.upcomingEvents);
        if (d.personalGoals)   setPersonalGoals(d.personalGoals);
        if (d.trainingModules) setTrainingModules(d.trainingModules);
        if (d.myAttendance)    setMyAttendance(d.myAttendance);
        if (d.benefits)        setBenefits(d.benefits);
      } else {
        // Seed defaults
        const defaults = {
          teamMembers: [
            { id:'t1', name:'Sarah Ahmed',   role:'Product Manager',   avatar:'', status:'online' },
            { id:'t2', name:'James Wilson',  role:'Senior Developer',  avatar:'', status:'busy'   },
            { id:'t3', name:'Maria Gonzalez',role:'UX Designer',       avatar:'', status:'away'   },
            { id:'t4', name:'David Chen',    role:'DevOps Engineer',   avatar:'', status:'offline'},
          ],
          announcements: [
            { id:'a1', title:'Company All-Hands Meeting', body:'Monthly all-hands on Friday at 3pm. All staff required.', time:'2 hours ago', priority:'high', type:'meeting' },
            { id:'a2', title:'Office Closure - Bank Holiday', body:'Office will be closed on Monday. Please plan accordingly.', time:'1 day ago', priority:'medium', type:'info' },
            { id:'a3', title:'New Benefits Package Available', body:'Updated health and wellness benefits are now live. Check the portal.', time:'3 days ago', priority:'low', type:'hr' },
          ],
          leaveBalance: { annual:25, sick:10, usedAnnual:8, usedSick:2, pending:2 },
          upcomingEvents: [
            { id:'e1', title:'1:1 with Manager', date:'Today 2:00 PM', icon:'account-supervisor', color:'#3B82F6' },
            { id:'e2', title:'Sprint Planning',  date:'Tomorrow 10:00 AM', icon:'calendar-clock', color:'#8B5CF6' },
            { id:'e3', title:'Team Lunch',       date:'Wed 12:30 PM', icon:'food', color:'#10B981' },
          ],
          personalGoals: [
            { id:'g1', title:'Complete React Native Course', progress:65, dueDate:'2026-04-01', category:'Learning' },
            { id:'g2', title:'Hit Q1 Sales Target',          progress:80, dueDate:'2026-03-31', category:'Work' },
            { id:'g3', title:'Get AWS Certification',        progress:30, dueDate:'2026-06-01', category:'Learning' },
          ],
          trainingModules: [
            { id:'tr1', title:'Security Awareness Training', status:'completed', dueDate:'2026-02-28', progress:100, category:'Compliance' },
            { id:'tr2', title:'Data Privacy & GDPR',         status:'in_progress', dueDate:'2026-03-31', progress:60, category:'Compliance' },
            { id:'tr3', title:'Leadership Essentials',       status:'not_started', dueDate:'2026-04-30', progress:0,  category:'Leadership' },
          ],
          myAttendance: { present:18, absent:1, late:2, rate:90, monthlyTarget:22 },
          benefits: [
            { id:'b1', icon:'heart-pulse',  label:'Health Insurance',    status:'Active',  detail:'BUPA Gold Plan' },
            { id:'b2', icon:'piggy-bank',   label:'Pension',             status:'Active',  detail:'5% contribution' },
            { id:'b3', icon:'umbrella',     label:'Life Insurance',      status:'Active',  detail:'4x annual salary' },
            { id:'b4', icon:'dumbbell',     label:'Gym Membership',      status:'Active',  detail:'PureGym All Access' },
            { id:'b5', icon:'bike',         label:'Cycle to Work',       status:'Available',detail:'Up to £1,000' },
          ],
        };
        setTeamMembers(defaults.teamMembers);
        setAnnouncements(defaults.announcements);
        setLeaveBalance(defaults.leaveBalance);
        setUpcomingEvents(defaults.upcomingEvents);
        setPersonalGoals(defaults.personalGoals);
        setTrainingModules(defaults.trainingModules);
        setMyAttendance(defaults.myAttendance);
        setBenefits(defaults.benefits);
        await AsyncStorage.setItem('employee_extended_data', JSON.stringify(defaults));
      }
    } catch (err) { console.warn('loadExtendedData error:', err); }
  };

  const persistGoal = async (goals) => {
    setPersonalGoals(goals);
    const stored = await AsyncStorage.getItem('employee_extended_data');
    const d = stored ? JSON.parse(stored) : {};
    await AsyncStorage.setItem('employee_extended_data', JSON.stringify({ ...d, personalGoals: goals }));
  };

  const submitLeaveRequest = async () => {
    if (!leaveDays || isNaN(parseInt(leaveDays))) {
      Alert.alert('Required', 'Enter number of days.'); return;
    }
    const req = { id:`lv_${Date.now()}`, type:leaveType, days:parseInt(leaveDays), note:leaveNote, status:'pending', requestedAt:new Date().toISOString() };
    const stored = await AsyncStorage.getItem('employee_extended_data');
    const d = stored ? JSON.parse(stored) : {};
    const pending = (d.leaveRequests || []);
    pending.push(req);
    await AsyncStorage.setItem('employee_extended_data', JSON.stringify({ ...d, leaveRequests: pending }));
    setLeaveBalance(p => ({ ...p, pending: (p.pending||0)+1 }));
    setShowLeaveModal(false); setLeaveDays(''); setLeaveNote('');
    Alert.alert('✅ Submitted', `${leaveDays} day(s) of ${leaveType} leave requested`);
  };

  const saveMood = async (mood) => {
    setTodayMood(mood);
    setShowMoodModal(false);
    const key = `mood_${new Date().toDateString()}`;
    await AsyncStorage.setItem(key, mood);
  };

  const loadTodayMood = async () => {
    const key = `mood_${new Date().toDateString()}`;
    const m = await AsyncStorage.getItem(key);
    if (m) setTodayMood(m);
  };

  useEffect(() => { loadTodayMood(); }, []);

  const loadWorkHours = async () => {
    try {
      const storedHours = await AsyncStorage.getItem('employee_work_hours');
      if (storedHours) {
        setWorkHours(JSON.parse(storedHours));
      } else {
        // Initialize with default hours
        const defaultHours = {
          today: 0,
          week: 0,
          month: 0,
          lastCheckIn: null,
          totalHoursThisWeek: 0,
        };
        setWorkHours(defaultHours);
        await AsyncStorage.setItem('employee_work_hours', JSON.stringify(defaultHours));
      }
    } catch (error) {
      console.error('Error loading work hours:', error);
    }
  };

  const checkWorkStatus = async () => {
    try {
      const checkedInStatus = await AsyncStorage.getItem('employee_checked_in');
      const lastCheckIn = await AsyncStorage.getItem('employee_last_checkin');
      
      setIsCheckedIn(checkedInStatus === 'true');
      
      // If checked in but no recent activity, auto check out after 12 hours
      if (checkedInStatus === 'true' && lastCheckIn) {
        const lastCheckInTime = new Date(lastCheckIn);
        const twelveHoursAgo = new Date(Date.now() - 12 * 60 * 60 * 1000);
        
        if (lastCheckInTime < twelveHoursAgo) {
          await handleAutoCheckOut();
        }
      }
    } catch (error) {
      console.error('Error checking work status:', error);
    }
  };

  const handleAutoCheckOut = async () => {
    try {
      await AsyncStorage.setItem('employee_checked_in', 'false');
      setIsCheckedIn(false);
      console.log('Auto checked out due to inactivity');
    } catch (error) {
      console.error('Error during auto check-out:', error);
    }
  };

  const handleCheckInOut = async () => {
    try {
      const newStatus = !isCheckedIn;
      const now = new Date();
      
      await AsyncStorage.setItem('employee_checked_in', newStatus.toString());
      await AsyncStorage.setItem('employee_last_checkin', now.toISOString());
      setIsCheckedIn(newStatus);

      // Update work hours
      if (newStatus) {
        // Check in
        await updateWorkHours('checkin', now);
      } else {
        // Check out
        await updateWorkHours('checkout', now);
      }
      
      const action = newStatus ? 'checked in' : 'checked out';
      Alert.alert(
        'Success',
        `You have successfully ${action} at ${currentTime.toLocaleTimeString()}`,
        [{ text: 'OK' }]
      );
    } catch (error) {
      console.error('Error updating check-in status:', error);
      Alert.alert('Error', 'Failed to update check-in status');
    }
  };

  const updateWorkHours = async (action, timestamp) => {
    try {
      const storedHours = await AsyncStorage.getItem('employee_work_hours');
      let hours = storedHours ? JSON.parse(storedHours) : { today: 0, week: 0, month: 0, lastCheckIn: null };
      
      if (action === 'checkin') {
        hours.lastCheckIn = timestamp.toISOString();
      } else if (action === 'checkout' && hours.lastCheckIn) {
        const checkInTime = new Date(hours.lastCheckIn);
        const checkOutTime = timestamp;
        const hoursWorked = (checkOutTime - checkInTime) / (1000 * 60 * 60); // Convert to hours
        
        hours.today += hoursWorked;
        hours.week += hoursWorked;
        hours.month += hoursWorked;
        hours.lastCheckIn = null;
        
        // Update state
        setWorkHours(prev => ({
          ...prev,
          today: parseFloat((prev.today + hoursWorked).toFixed(2)),
          week: parseFloat((prev.week + hoursWorked).toFixed(2)),
          month: parseFloat((prev.month + hoursWorked).toFixed(2)),
        }));
      }
      
      await AsyncStorage.setItem('employee_work_hours', JSON.stringify(hours));
    } catch (error) {
      console.error('Error updating work hours:', error);
    }
  };

  const onRefresh = async () => {
    setRefreshing(true);
    await Promise.all([
      loadDashboardData(),
      checkWorkStatus(),
      loadWorkHours(),
      loadPayrollData(),
    ]);
    setRefreshing(false);
  };

  const handleLogout = async () => {
    Alert.alert(
      'Logout',
      'Are you sure you want to logout?',
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Logout',
          style: 'destructive',
          onPress: async () => {
            try {
              // Auto check out if still checked in
              if (isCheckedIn) {
                await handleCheckInOut();
              }
              
              await logout();
              navigation.reset({ index: 0, routes: [{ name: 'Home' }] });
            } catch (error) {
              console.error('Logout error:', error);
              Alert.alert('Error', 'Failed to logout properly');
            }
          },
        },
      ]
    );
  };

  const handleNotificationPress = (notification) => {
    setShowNotifications(false);
    
    if (notification.action) {
      switch (notification.action) {
        case 'view_task':
          navigation.navigate('TaskDetails', notification.actionParams);
          break;
        case 'view_calendar':
          navigation.navigate('Calendar');
          break;
        case 'view_timesheet':
          navigation.navigate('Timesheet');
          break;
        case 'view_payslips':
          setShowPayslipsModal(true);
          break;
        case 'view_payroll':
          setShowPayrollFullModal(true);
          break;
        default:
          break;
      }
    }
    
    // Mark as read
    markNotificationAsRead(notification.id);
  };

  const markNotificationAsRead = async (notificationId) => {
    const updatedNotifications = (notifications||[]).map(notif =>
      notif.id === notificationId ? { ...notif, read: true } : notif
    );
    setNotifications(updatedNotifications);
    
    // Update in storage
    const storedData = await AsyncStorage.getItem('employee_dashboard_data');
    if (storedData) {
      const data = JSON.parse(storedData);
      await AsyncStorage.setItem('employee_dashboard_data', JSON.stringify({
        ...data,
        notifications: updatedNotifications,
      }));
    }
  };

  const markAllNotificationsAsRead = async () => {
    const updatedNotifications = (notifications||[]).map(notif => ({ ...notif, read: true }));
    setNotifications(updatedNotifications);
    
    // Update in storage
    const storedData = await AsyncStorage.getItem('employee_dashboard_data');
    if (storedData) {
      const data = JSON.parse(storedData);
      await AsyncStorage.setItem('employee_dashboard_data', JSON.stringify({
        ...data,
        notifications: updatedNotifications,
      }));
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high': return '#ef4444';
      case 'medium': return '#f59e0b';
      case 'low': return '#10b981';
      default: return '#6b7280';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return '#10b981';
      case 'in_progress': return '#3b82f6';
      case 'pending': return '#f59e0b';
      default: return '#6b7280';
    }
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString([], { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const calculateTimeRemaining = (dueDate) => {
    const due = new Date(dueDate);
    const now = new Date();
    const diffTime = due - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays < 0) return { text: 'Overdue', color: '#ef4444' };
    if (diffDays === 0) return { text: 'Due today', color: '#f59e0b' };
    if (diffDays === 1) return { text: 'Due tomorrow', color: '#f59e0b' };
    if (diffDays <= 7) return { text: `Due in ${diffDays} days`, color: '#f59e0b' };
    return { text: `Due in ${diffDays} days`, color: '#6b7280' };
  };

  const renderTaskItem = ({ item, index }) => (
    <Animated.View
      style={{
        opacity: fadeAnim,
        transform: [{
          translateY: fadeAnim.interpolate({
            inputRange: [0, 1],
            outputRange: [50 * (index + 1), 0],
          }),
        }],
      }}
    >
      <TouchableOpacity 
        style={styles.taskCard}
        onPress={() => navigation.navigate('TaskDetails', { taskId: item.id })}
      >
        <View style={styles.taskHeader}>
          <View style={styles.taskTitleContainer}>
            <Text style={styles.taskTitle}>{item.title}</Text>
            <Text style={styles.taskProject}>{item.project}</Text>
          </View>
          <View style={[styles.priorityBadge, { backgroundColor: getPriorityColor(item.priority) }]}>
            <Text style={styles.priorityText}>{String(item.priority ?? '').toUpperCase()}</Text>
          </View>
        </View>
        
        <View style={styles.taskProgress}>
          <View style={styles.progressBar}>
            <View style={[styles.progressFill, { width: `${item.progress}%` }]} />
          </View>
          <Text style={styles.progressText}>{item.progress}%</Text>
        </View>
        
        <View style={styles.taskFooter}>
          <View style={styles.taskStatus}>
            <MaterialCommunityIcons 
              name="clock-outline" 
              size={16} 
              color={getStatusColor(item.status)} 
            />
            <Text style={[styles.statusText, { color: getStatusColor(item.status) }]}>
              {item.status.replace('_', ' ').toUpperCase()}
            </Text>
          </View>
          <View style={styles.taskMeta}>
            <Text style={[styles.dueDate, { color: calculateTimeRemaining(item.dueDate).color }]}>
              {calculateTimeRemaining(item.dueDate).text}
            </Text>
            <Text style={styles.hoursText}>
              {item.actualHours}/{item.estimatedHours}h
            </Text>
          </View>
        </View>
      </TouchableOpacity>
    </Animated.View>
  );

  const renderProjectItem = ({ item, index }) => (
    <Animated.View
      style={{
        opacity: fadeAnim,
        transform: [{
          translateY: fadeAnim.interpolate({
            inputRange: [0, 1],
            outputRange: [50 * (index + 1), 0],
          }),
        }],
      }}
    >
      <TouchableOpacity 
        style={styles.projectCard}
        onPress={() => navigation.navigate('ProjectDetails', { projectId: item.id })}
      >
        <View style={styles.projectHeader}>
          <Text style={styles.projectName}>{item.name}</Text>
          <View style={[styles.statusBadge, { backgroundColor: getStatusColor(item.status) }]}>
            <Text style={styles.statusBadgeText}>{String(item.status ?? '').toUpperCase()}</Text>
          </View>
        </View>
        
        <Text style={styles.projectRole}>Role: {item.role}</Text>
        
        <View style={styles.projectProgress}>
          <View style={styles.progressBar}>
            <View style={[styles.progressFill, { width: `${item.progress}%` }]} />
          </View>
          <Text style={styles.progressText}>{item.progress}%</Text>
        </View>
        
        <View style={styles.projectFooter}>
          <View style={styles.projectInfo}>
            <MaterialCommunityIcons name="account-group" size={16} color="#6b7280" />
            <Text style={styles.projectInfoText}>{item.team} members</Text>
          </View>
          <View style={styles.projectBudget}>
            <MaterialCommunityIcons name="cash" size={14} color="#6b7280" />
            <Text style={styles.budgetText}>
              ${(item.spent / 1000).toFixed(0)}k/${(item.budget / 1000).toFixed(0)}k
            </Text>
          </View>
        </View>
      </TouchableOpacity>
    </Animated.View>
  );



  // ── Payslip PDF Export ──
  const buildPayslipHTML = (slip) => {
    const empName = slip?.employeeName || user?.name || user?.full_name || 'Employee';
    const empEmail = user?.email || '';
    const empDept = user?.department || employeeDept || '';
    const empPos = user?.position || employeeRole || '';
    const gross = slip?.gross || slip?.grossPay || 0;
    const tax = slip?.tax || slip?.incomeTax || 0;
    const ni = slip?.ni || slip?.nationalInsurance || 0;
    const pension = slip?.employeePension || slip?.pension || 0;
    const studentLoan = slip?.studentLoan || 0;
    const bonus = slip?.bonus || 0;
    const overtime = slip?.overtime || slip?.overtimePay || 0;
    const allowances = slip?.allowances || 0;
    const net = slip?.net || slip?.netPay || 0;
    const period = formatPayPeriod(slip?.period || slip?.date);

    const addRow = (label, amount, color) =>
      amount > 0 ? `<tr><td>${label}</td><td style="text-align:right;color:${color||'#222'}">£${amount.toFixed(2)}</td></tr>` : '';

    return `<!DOCTYPE html><html><head><meta charset="utf-8"/><style>
*{box-sizing:border-box;margin:0;padding:0}body{font-family:-apple-system,sans-serif;color:#222;padding:28px}
.hdr{border-bottom:3px solid #1a365d;padding-bottom:16px;margin-bottom:20px;display:flex;justify-content:space-between}
.co{font-size:20px;color:#1a365d;font-weight:bold}.sub{font-size:12px;color:#666}
.title{font-size:24px;color:#1a365d;text-align:right;font-weight:bold}
.emp{background:#f8fafc;border-radius:8px;padding:14px;margin-bottom:16px}
.emp td{padding:4px 10px;font-size:13px}.emp td:first-child{font-weight:600;color:#555;width:35%}
.section{margin-bottom:16px}.section h3{font-size:14px;color:#1a365d;margin-bottom:8px;border-bottom:1px solid #e2e8f0;padding-bottom:4px}
table.items{width:100%;border-collapse:collapse}table.items td{padding:8px 10px;border-bottom:1px solid #f1f5f9;font-size:13px}
.total{border-top:2px solid #1a365d;font-weight:bold;font-size:15px}
.net{background:#f0fdf4;border-radius:8px;padding:14px;text-align:center;margin-top:16px}
.net span{font-size:28px;color:#10b981;font-weight:bold}
.ft{margin-top:20px;text-align:center;font-size:10px;color:#aaa;border-top:1px solid #eee;padding-top:8px}
</style></head><body>
<div class="hdr"><div><div class="co">PAYSLIP</div><div class="sub">${period}</div></div><div class="title">£${net.toFixed(2)}<br/><span style="font-size:12px;color:#666;font-weight:normal">Net Pay</span></div></div>
<table class="emp"><tr><td>Name</td><td>${empName}</td></tr><tr><td>Email</td><td>${empEmail}</td></tr>
${empDept ? '<tr><td>Department</td><td>'+empDept+'</td></tr>' : ''}
${empPos ? '<tr><td>Position</td><td>'+empPos+'</td></tr>' : ''}
<tr><td>Tax Code</td><td>${payrollSummary.taxCode}</td></tr><tr><td>NI Category</td><td>${payrollSummary.niCategory}</td></tr>
${payrollExtended.salary ? '<tr><td>Annual Salary</td><td>£'+payrollExtended.salary.toLocaleString()+'</td></tr>' : ''}
</table>
<div class="section"><h3>Earnings</h3><table class="items">
<tr><td>Basic Pay</td><td style="text-align:right">£${gross.toFixed(2)}</td></tr>
${addRow('Bonus', bonus)}${addRow('Overtime', overtime)}${addRow('Allowances', allowances)}
</table></div>
<div class="section"><h3>Deductions</h3><table class="items">
${addRow('Income Tax', tax, '#ef4444')}${addRow('National Insurance', ni, '#ef4444')}
${addRow('Pension', pension, '#8b5cf6')}${addRow('Student Loan', studentLoan, '#ef4444')}
</table></div>
<div class="net"><div style="font-size:12px;color:#666">NET PAY</div><span>£${net.toFixed(2)}</span></div>
<div class="ft">PERSONAL & CONFIDENTIAL · Generated ${new Date().toLocaleDateString('en-GB')} · Powered by JOBENG</div>
</body></html>`;
  };

  const exportPayslipPDF = async (slip) => {
    setPayslipPdfLoading(true);
    try {
      const html = buildPayslipHTML(slip || selectedPayslip);
      try {
        const { uri } = await Print.printToFileAsync({ html, base64: false });
        const available = await Sharing.isAvailableAsync();
        if (available) {
          await Sharing.shareAsync(uri, { mimeType: 'application/pdf', dialogTitle: `Payslip - ${formatPayPeriod(slip?.period || slip?.date)}`, UTI: 'com.adobe.pdf' });
          return;
        }
      } catch (fe) { console.warn('printToFileAsync unavailable:', fe?.message); }
      await Print.printAsync({ html });
    } catch (e) { Alert.alert('Error', 'PDF export failed'); }
    finally { setPayslipPdfLoading(false); }
  };

  const printPayslip = async (slip) => {
    try { await Print.printAsync({ html: buildPayslipHTML(slip || selectedPayslip) }); }
    catch { Alert.alert('Error', 'Print failed'); }
  };

  const buildP60HTML = () => {
    const empName = user?.name || user?.full_name || 'Employee';
    return `<!DOCTYPE html><html><head><meta charset="utf-8"/><style>
*{box-sizing:border-box;margin:0;padding:0}body{font-family:-apple-system,sans-serif;color:#222;padding:28px}
.hdr{border-bottom:3px solid #1a365d;padding-bottom:14px;margin-bottom:18px}
.hdr h1{font-size:22px;color:#1a365d}.sub{font-size:12px;color:#666}
table{width:100%;border-collapse:collapse;margin:10px 0}td{padding:8px 10px;border-bottom:1px solid #eee;font-size:13px}
td:first-child{font-weight:600;color:#555;width:40%}
.total td{font-weight:bold;border-top:2px solid #1a365d;font-size:14px}
.ft{margin-top:20px;text-align:center;font-size:10px;color:#aaa}
</style></head><body>
<div class="hdr"><h1>P60 End of Year Certificate</h1><div class="sub">Tax Year ${new Date().getFullYear()-1}/${new Date().getFullYear()} · ${empName}</div></div>
<table>
<tr><td>Employee</td><td>${empName}</td></tr>
<tr><td>Tax Code</td><td>${payrollSummary.taxCode}</td></tr>
<tr><td>NI Category</td><td>${payrollSummary.niCategory}</td></tr>
<tr><td>Total Gross Pay</td><td>£${payrollSummary.ytdGross.toFixed(2)}</td></tr>
<tr><td>Total Tax Deducted</td><td>£${payrollSummary.ytdTax.toFixed(2)}</td></tr>
<tr><td>Total NI Contributions</td><td>£${payrollSummary.ytdNI.toFixed(2)}</td></tr>
<tr><td>Total Pension</td><td>£${payrollSummary.ytdPension.toFixed(2)}</td></tr>
<tr class="total"><td>Total Net Pay</td><td>£${payrollSummary.ytdNet.toFixed(2)}</td></tr>
</table>
<div class="ft">PERSONAL & CONFIDENTIAL · Generated ${new Date().toLocaleDateString('en-GB')} · This is not an official HMRC document</div>
</body></html>`;
  };

  const exportP60 = async () => {
    try {
      const html = buildP60HTML();
      try {
        const { uri } = await Print.printToFileAsync({ html });
        const available = await Sharing.isAvailableAsync();
        if (available) { await Sharing.shareAsync(uri, { mimeType: 'application/pdf', dialogTitle: 'P60 Certificate' }); return; }
      } catch {}
      await Print.printAsync({ html });
    } catch { Alert.alert('Error', 'P60 export failed'); }
  };

  const PayrollSummaryCard = () => (
    <Animated.View
      style={[
        styles.payrollCard,
        {
          opacity: fadeAnim,
          transform: [{
            translateY: fadeAnim.interpolate({
              inputRange: [0, 1],
              outputRange: [45, 0],
            }),
          }],
        }
      ]}
    >
      <View style={styles.payrollCardHeader}>
        <View style={styles.payrollCardTitleRow}>
          <MaterialCommunityIcons name="currency-gbp" size={22} color="#8b5cf6" />
          <Text style={styles.payrollCardTitle}>My Pay Summary</Text>
          <View style={{ backgroundColor: '#8b5cf610', borderRadius: 8, paddingHorizontal: 6, paddingVertical: 2, marginLeft: 6 }}>
            <Text style={{ fontSize: 9, color: '#8b5cf6', fontWeight: '700' }}>PERSONAL</Text>
          </View>
        </View>
        <TouchableOpacity onPress={() => setShowPayslipsModal(true)} style={styles.payrollViewAllBtn}>
          <Text style={styles.payrollViewAllText}>View Payslips</Text>
          <MaterialCommunityIcons name="chevron-right" size={16} color="#8b5cf6" />
        </TouchableOpacity>
      </View>
      
      <View style={styles.payrollCardBody}>
        <View style={styles.payrollMainStats}>
          <View style={styles.payrollMainStat}>
            <Text style={styles.payrollMainLabel}>Last Net Pay</Text>
            <Text style={styles.payrollMainValue}>
              {payrollSummary.lastNetPay > 0 ? formatCurrency(payrollSummary.lastNetPay) : '—'}
            </Text>
            {payrollSummary.lastPayDate ? (
              <Text style={styles.payrollMainSubtext}>{formatPayPeriod(payrollSummary.lastPayDate)}</Text>
            ) : null}
          </View>
          <View style={styles.payrollDivider} />
          <View style={styles.payrollMainStat}>
            <Text style={styles.payrollMainLabel}>Next Pay Date</Text>
            <Text style={[styles.payrollMainValue, { color: '#10b981' }]}>
              {payrollSummary.nextPayDate
                ? new Date(payrollSummary.nextPayDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })
                : '—'}
            </Text>
            <Text style={styles.payrollMainSubtext}>Tax Code: {payrollSummary.taxCode}</Text>
          </View>
        </View>
        
        <View style={styles.ytdSection}>
          <Text style={styles.ytdTitle}>Year-to-Date Earnings</Text>
          <View style={styles.ytdGrid}>
            <View style={styles.ytdItem}>
              <Text style={styles.ytdLabel}>Gross</Text>
              <Text style={[styles.ytdValue, { color: '#1f2937' }]}>
                {payrollSummary.ytdGross > 0 ? formatCurrency(payrollSummary.ytdGross) : '—'}
              </Text>
            </View>
            <View style={styles.ytdItem}>
              <Text style={styles.ytdLabel}>Tax</Text>
              <Text style={[styles.ytdValue, { color: '#ef4444' }]}>
                {payrollSummary.ytdTax > 0 ? formatCurrency(payrollSummary.ytdTax) : '—'}
              </Text>
            </View>
            <View style={styles.ytdItem}>
              <Text style={styles.ytdLabel}>NI</Text>
              <Text style={[styles.ytdValue, { color: '#f59e0b' }]}>
                {payrollSummary.ytdNI > 0 ? formatCurrency(payrollSummary.ytdNI) : '—'}
              </Text>
            </View>
            <View style={styles.ytdItem}>
              <Text style={styles.ytdLabel}>Pension</Text>
              <Text style={[styles.ytdValue, { color: '#8b5cf6' }]}>
                {payrollSummary.ytdPension > 0 ? formatCurrency(payrollSummary.ytdPension) : '—'}
              </Text>
            </View>
          </View>
          {payrollSummary.ytdNet > 0 && (
            <View style={styles.ytdNetRow}>
              <Text style={styles.ytdNetLabel}>YTD Net Pay</Text>
              <Text style={styles.ytdNetValue}>{formatCurrency(payrollSummary.ytdNet)}</Text>
            </View>
          )}
        </View>

        {/* Salary & Extras */}
        {payrollExtended.salary > 0 && (
          <View style={{ marginTop: 12, paddingTop: 12, borderTopWidth: 1, borderTopColor: '#f1f5f9' }}>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 6 }}>
              <Text style={{ fontSize: 12, color: '#6b7280' }}>Annual Salary</Text>
              <Text style={{ fontSize: 14, fontWeight: '700', color: '#1f2937' }}>£{payrollExtended.salary.toLocaleString()}</Text>
            </View>
            <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 6 }}>
              <Text style={{ fontSize: 12, color: '#6b7280' }}>Monthly Gross</Text>
              <Text style={{ fontSize: 13, fontWeight: '600', color: '#1f2937' }}>£{(payrollExtended.salary / 12).toFixed(2)}</Text>
            </View>
            {payrollExtended.bonus > 0 && (
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4 }}>
                <Text style={{ fontSize: 12, color: '#6b7280' }}>Bonus</Text>
                <Text style={{ fontSize: 13, fontWeight: '600', color: '#10b981' }}>+£{payrollExtended.bonus.toLocaleString()}</Text>
              </View>
            )}
            {payrollExtended.overtime > 0 && (
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4 }}>
                <Text style={{ fontSize: 12, color: '#6b7280' }}>Overtime</Text>
                <Text style={{ fontSize: 13, fontWeight: '600', color: '#10b981' }}>+£{payrollExtended.overtime.toLocaleString()}</Text>
              </View>
            )}
            {payrollExtended.allowances > 0 && (
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', marginBottom: 4 }}>
                <Text style={{ fontSize: 12, color: '#6b7280' }}>Allowances</Text>
                <Text style={{ fontSize: 13, fontWeight: '600', color: '#10b981' }}>+£{payrollExtended.allowances.toLocaleString()}</Text>
              </View>
            )}
          </View>
        )}

        {/* Payment & Actions row */}
        <View style={{ flexDirection: 'row', marginTop: 12, gap: 8 }}>
          <TouchableOpacity onPress={() => setShowPayrollFullModal(true)}
            style={{ flex: 1, backgroundColor: '#8b5cf620', borderRadius: 10, paddingVertical: 10, alignItems: 'center', flexDirection: 'row', justifyContent: 'center', gap: 6 }}>
            <MaterialCommunityIcons name="information-outline" size={16} color="#8b5cf6" />
            <Text style={{ fontSize: 12, fontWeight: '700', color: '#8b5cf6' }}>Full Details</Text>
          </TouchableOpacity>
          {payrollSummary.ytdGross > 0 && (
            <TouchableOpacity onPress={exportP60}
              style={{ flex: 1, backgroundColor: '#1a365d15', borderRadius: 10, paddingVertical: 10, alignItems: 'center', flexDirection: 'row', justifyContent: 'center', gap: 6 }}>
              <MaterialCommunityIcons name="file-certificate-outline" size={16} color="#1a365d" />
              <Text style={{ fontSize: 12, fontWeight: '700', color: '#1a365d' }}>P60</Text>
            </TouchableOpacity>
          )}
        </View>
      </View>
    </Animated.View>
  );

  const PayslipItem = ({ payslip, onPress }) => (
    <TouchableOpacity style={styles.payslipItem} onPress={onPress}>
      <View style={styles.payslipIcon}>
        <MaterialCommunityIcons name="file-document-outline" size={24} color="#8b5cf6" />
      </View>
      <View style={styles.payslipInfo}>
        <Text style={styles.payslipPeriod}>
          {formatPayPeriod(payslip.period || payslip.date)}
        </Text>
        <Text style={styles.payslipGross}>
          Gross: {formatCurrency(payslip.gross || payslip.grossPay || 0)}
        </Text>
      </View>
      <View style={styles.payslipRight}>
        <Text style={styles.payslipNet}>
          {formatCurrency(payslip.net || payslip.netPay || 0)}
        </Text>
        <Text style={styles.payslipNetLabel}>Net</Text>
      </View>
      <MaterialCommunityIcons name="chevron-right" size={18} color="#d1d5db" />
    </TouchableOpacity>
  );

  const QuickActionButton = ({ icon, text, onPress, color = '#3b82f6' }) => (
    <TouchableOpacity style={styles.actionCard} onPress={onPress}>
      <View style={[styles.actionIcon, { backgroundColor: color + '20' }]}>
        <MaterialCommunityIcons name={icon} size={24} color={color} />
      </View>
      <Text style={styles.actionText}>{text}</Text>
    </TouchableOpacity>
  );

  return (
    <SafeAreaView style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor="#1a365d" />
      
      {/* Header */}
      <LinearGradient colors={['#1a365d', '#2d5a87']} style={styles.header}>
        {/* Back button when viewing another employee's dashboard */}
        {canGoBack && (
          <TouchableOpacity
            onPress={() => navigation.goBack()}
            style={{ flexDirection:'row', alignItems:'center', paddingHorizontal:16, paddingTop:8, paddingBottom:4 }}
          >
            <MaterialCommunityIcons name="arrow-left" size={20} color="#ffffff" />
            <Text style={{ color:'#ffffff', fontSize:13, fontWeight:'600', marginLeft:6 }}>Employee Management</Text>
          </TouchableOpacity>
        )}
        <View style={styles.headerTop}>
          <View style={styles.userInfo}>
            <Image 
              source={{ uri: user?.avatar || 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face' }}
              style={styles.avatar}
            />
            <View style={styles.userDetails}>
              <Text style={styles.userName}>
                {user?.name || user?.full_name || 'Employee'}
              </Text>
              <Text style={styles.userRole}>
                {user?.role?.name || user?.userType || 'Employee'}
              </Text>
              <Text style={styles.companyName}>
                {user?.company?.name || 'JobEng Construction'}
              </Text>
            </View>
          </View>
          
          <View style={styles.headerActions}>
            <TouchableOpacity 
              style={styles.headerButton}
              onPress={() => setShowNotifications(true)}
            >
              <MaterialCommunityIcons name="bell" size={24} color="#ffffff" />
              {(notifications||[]).filter(n => !n.read).length > 0 && (
                <View style={styles.notificationBadge}>
                  <Text style={styles.notificationBadgeText}>
                    {(notifications||[]).filter(n => !n.read).length}
                  </Text>
                </View>
              )}
            </TouchableOpacity>
            
            <TouchableOpacity 
              style={styles.headerButton}
              onPress={() => setShowProfile(true)}
            >
              <MaterialCommunityIcons name="account-circle" size={24} color="#ffffff" />
            </TouchableOpacity>
          </View>
        </View>
        
        <View style={styles.timeInfo}>
          <Text style={styles.currentTime}>{formatTime(currentTime)}</Text>
          <Text style={styles.currentDate}>{formatDate(currentTime)}</Text>
        </View>
      </LinearGradient>

      <ScrollView 
        style={styles.content}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} tintColor="#1a365d" />
        }
        showsVerticalScrollIndicator={false}
      >
        {/* Check-in/Check-out Section */}
        <Animated.View 
          style={[
            styles.checkInSection,
            {
              opacity: fadeAnim,
              transform: [{
                translateY: fadeAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: [30, 0],
                }),
              }],
            }
          ]}
        >
          <TouchableOpacity 
            style={[styles.checkInButton, isCheckedIn ? styles.checkOutButton : styles.checkInButtonActive]}
            onPress={() => navigation.navigate('AttendanceScreen', {
              employee: routeEmployee || user,
              employeeId: user?.id || user?.serverId || user?.employeeId,
            })}
          >
            <MaterialCommunityIcons 
              name={isCheckedIn ? "logout" : "login"} 
              size={24} 
              color="#ffffff" 
            />
            <Text style={styles.checkInButtonText}>
              <Text>{isCheckedIn ? 'Checked In · Tap to manage' : 'Tap to Clock In'}</Text>
            </Text>
          </TouchableOpacity>
          
          <View style={styles.workHoursInfo}>
            <View style={styles.workHourItem}>
              <Text style={styles.workHourLabel}>Today</Text>
              <Text style={styles.workHourValue}>{workHours.today.toFixed(1)}h</Text>
            </View>
            <View style={styles.workHourItem}>
              <Text style={styles.workHourLabel}>This Week</Text>
              <Text style={styles.workHourValue}>{workHours.week.toFixed(1)}h</Text>
            </View>
            <View style={styles.workHourItem}>
              <Text style={styles.workHourLabel}>This Month</Text>
              <Text style={styles.workHourValue}>{workHours.month.toFixed(1)}h</Text>
            </View>
          </View>
        </Animated.View>

        {/* Dashboard Stats */}
        <Animated.View 
          style={[
            styles.statsContainer,
            {
              opacity: fadeAnim,
              transform: [{
                translateY: fadeAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: [40, 0],
                }),
              }],
            }
          ]}
        >
          <View style={styles.statCard}>
            <MaterialCommunityIcons name="clipboard-list" size={32} color="#3b82f6" />
            <Text style={styles.statValue}>{dashboardStats.activeTasks}</Text>
            <Text style={styles.statLabel}>Active Tasks</Text>
          </View>
          
          <View style={styles.statCard}>
            <MaterialCommunityIcons name="check-circle" size={32} color="#10b981" />
            <Text style={styles.statValue}>{dashboardStats.completedTasks}</Text>
            <Text style={styles.statLabel}>Completed</Text>
          </View>
          
          <View style={styles.statCard}>
            <MaterialCommunityIcons name="folder-multiple" size={32} color="#f59e0b" />
            <Text style={styles.statValue}>{dashboardStats.activeProjects}</Text>
            <Text style={styles.statLabel}>Projects</Text>
          </View>
          
          <View style={styles.statCard}>
            <MaterialCommunityIcons name="clock-alert" size={32} color="#ef4444" />
            <Text style={styles.statValue}>{dashboardStats.pendingApprovals}</Text>
            <Text style={styles.statLabel}>Pending</Text>
          </View>
        </Animated.View>

        {/* Payroll Summary */}
        <PayrollSummaryCard />

        {/* Quick Actions */}
        <Animated.View 
          style={[
            styles.quickActions,
            {
              opacity: fadeAnim,
              transform: [{
                translateY: fadeAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: [50, 0],
                }),
              }],
            }
          ]}
        >
          <Text style={styles.sectionTitle}>Quick Actions</Text>
          <View style={styles.actionGrid}>
            <QuickActionButton
              icon="clipboard-list"
              text="My Tasks"
              onPress={() => navigation.navigate('TaskList')}
              color="#3b82f6"
            />
            <QuickActionButton
              icon="clock"
              text="Timesheet"
              onPress={() => navigation.navigate('Timesheet')}
              color="#10b981"
            />
            <QuickActionButton
              icon="calendar-remove"
              text="Leave Request"
              onPress={() => navigation.navigate('LeaveRequest')}
              color="#f59e0b"
            />
            <QuickActionButton
              icon="receipt"
              text="Expenses"
              onPress={() => navigation.navigate('ExpenseReport')}
              color="#8b5cf6"
            />
            <QuickActionButton
              icon="file-document"
              text="Reports"
              onPress={() => navigation.navigate('Reports')}
              color="#ef4444"
            />
            <QuickActionButton
              icon="message-text"
              text="Messages"
              onPress={() => navigation.navigate('MessagesScreen')}
              color="#06b6d4"
            />
            <QuickActionButton
              icon="file-document-multiple"
              text="Payslips"
              onPress={() => setShowPayslipsModal(true)}
              color="#8b5cf6"
            />
            <QuickActionButton
              icon="cash-multiple"
              text="My Payroll"
              onPress={() => setShowPayrollFullModal(true)}
              color="#10b981"
            />
            <QuickActionButton
              icon="palm-tree"
              text="Leave"
              onPress={() => setShowLeaveModal(true)}
              color="#f59e0b"
            />
            <QuickActionButton
              icon="target"
              text="My Goals"
              onPress={() => setShowGoalModal(true)}
              color="#8b5cf6"
            />
            <QuickActionButton
              icon="account-group"
              text="My Team"
              onPress={() => setShowTeamModal(true)}
              color="#0ea5e9"
            />
            <QuickActionButton
              icon="school"
              text="Training"
              onPress={() => navigation.navigate('Training')}
              color="#ec4899"
            />
            <QuickActionButton
              icon="heart-pulse"
              text="Benefits"
              onPress={() => navigation.navigate('Benefits')}
              color="#14b8a6"
            />
            <QuickActionButton
              icon="chart-line"
              text="Performance"
              onPress={() => navigation.navigate('PerformanceReview')}
              color="#6366f1"
            />
          </View>
        </Animated.View>

        {/* Recent Tasks */}
        <Animated.View 
          style={[
            styles.section,
            {
              opacity: fadeAnim,
              transform: [{
                translateY: fadeAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: [60, 0],
                }),
              }],
            }
          ]}
        >
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>Recent Tasks</Text>
            <TouchableOpacity 
              style={styles.seeAllButton}
              onPress={() => navigation.navigate('TaskList')}
            >
              <Text style={styles.seeAllText}>See All</Text>
              <MaterialCommunityIcons name="chevron-right" size={16} color="#4a90e2" />
            </TouchableOpacity>
          </View>
          
          <FlatList
            data={(tasks||[]).slice(0, 3)}
            renderItem={renderTaskItem}
            keyExtractor={(item) => item.id.toString()}
            scrollEnabled={false}
            showsVerticalScrollIndicator={false}
          />
        </Animated.View>

        {/* Active Projects */}
        <Animated.View 
          style={[
            styles.section,
            {
              opacity: fadeAnim,
              transform: [{
                translateY: fadeAnim.interpolate({
                  inputRange: [0, 1],
                  outputRange: [70, 0],
                }),
              }],
            }
          ]}
        >
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>Active Projects</Text>
            <TouchableOpacity 
              style={styles.seeAllButton}
              onPress={() => navigation.navigate('ProjectList')}
            >
              <Text style={styles.seeAllText}>See All</Text>
              <MaterialCommunityIcons name="chevron-right" size={16} color="#4a90e2" />
            </TouchableOpacity>
          </View>
          
          <FlatList
            data={(projects||[]).filter(p => p.status === 'active')}
            renderItem={renderProjectItem}
            keyExtractor={(item) => item.id.toString()}
            scrollEnabled={false}
            showsVerticalScrollIndicator={false}
          />
        </Animated.View>

        {/* ── Mood Check-in strip ────────────────────────── */}
        {!todayMood && (
          <Animated.View style={[styles.section,{opacity:fadeAnim,borderLeftWidth:4,borderLeftColor:'#F59E0B'}]}>
            <View style={styles.sectionHeader}>
              <Text style={styles.sectionTitle}>How are you feeling today?</Text>
            </View>
            <View style={{flexDirection:'row',justifyContent:'space-around'}}>
              {[['😊','Great','#10B981'],['🙂','Good','#3B82F6'],['😐','Okay','#F59E0B'],['😔','Down','#EF4444']].map(([emoji,label,color])=>(
                <TouchableOpacity key={label} onPress={()=>saveMood(label)}
                  style={{alignItems:'center',backgroundColor:color+'15',borderRadius:14,padding:12,minWidth:64}}>
                  <Text style={{fontSize:24}}>{emoji}</Text>
                  <Text style={{fontSize:11,color,fontWeight:'700',marginTop:4}}>{label}</Text>
                </TouchableOpacity>
              ))}
            </View>
          </Animated.View>
        )}
        {todayMood && (
          <TouchableOpacity style={[styles.section,{flexDirection:'row',alignItems:'center',gap:10,opacity:0.9}]} onPress={()=>setTodayMood(null)}>
            <Text style={{fontSize:20}}>
              <Text>{todayMood==='Great'?'😊':todayMood==='Good'?'🙂':todayMood==='Okay'?'😐':'😔'}</Text>
            </Text>
            <Text style={{fontSize:14,color:'#374151'}}>Feeling <Text style={{fontWeight:'700'}}>{todayMood}</Text> today</Text>
            <Text style={{fontSize:11,color:'#9CA3AF',marginLeft:'auto'}}>Tap to change</Text>
          </TouchableOpacity>
        )}

        {/* ── Announcements ──────────────────────────────── */}
        {(announcements||[]).length > 0 && (
          <Animated.View style={[styles.section,{opacity:fadeAnim}]}>
            <View style={styles.sectionHeader}>
              <Text style={styles.sectionTitle}>📢 Announcements</Text>
              <TouchableOpacity style={styles.seeAllButton} onPress={()=>setShowAnnounceModal(true)}>
                <Text style={styles.seeAllText}>All</Text>
                <MaterialCommunityIcons name="chevron-right" size={16} color="#4a90e2"/>
              </TouchableOpacity>
            </View>
            {(announcements||[]).slice(0,2).map((a,i)=>{
              const iconMap={meeting:'calendar-clock',info:'information',hr:'account-heart'};
              const colorMap={high:'#EF4444',medium:'#F59E0B',low:'#10B981'};
              return(
                <View key={a.id||i} style={{flexDirection:'row',alignItems:'flex-start',paddingVertical:10,borderBottomWidth:i<1?1:0,borderBottomColor:'#F1F5F9',gap:10}}>
                  <View style={{width:36,height:36,borderRadius:18,backgroundColor:(colorMap[a.priority]||'#3B82F6')+'15',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                    <MaterialCommunityIcons name={iconMap[a.type]||'bell'} size={18} color={colorMap[a.priority]||'#3B82F6'}/>
                  </View>
                  <View style={{flex:1}}>
                    <Text style={{fontSize:13,fontWeight:'700',color:'#1F2937'}}>{a.title}</Text>
                    <Text style={{fontSize:12,color:'#6B7280',marginTop:2,lineHeight:17}} numberOfLines={2}>{a.body}</Text>
                    <Text style={{fontSize:10,color:'#9CA3AF',marginTop:3}}>{a.time}</Text>
                  </View>
                  {a.priority==='high'&&<View style={{backgroundColor:'#FEF2F2',borderRadius:8,paddingHorizontal:8,paddingVertical:3,alignSelf:'flex-start'}}>
                    <Text style={{fontSize:10,fontWeight:'700',color:'#EF4444'}}>URGENT</Text>
                  </View>}
                </View>
              );
            })}
          </Animated.View>
        )}

        {/* ── Leave Balance ──────────────────────────────── */}
        <Animated.View style={[styles.section,{opacity:fadeAnim}]}>
          <View style={styles.sectionHeader}>
            <Text style={styles.sectionTitle}>🌴 Leave Balance</Text>
            <TouchableOpacity style={[styles.seeAllButton,{backgroundColor:'#3B82F6',borderRadius:8,paddingHorizontal:10,paddingVertical:5}]}
              onPress={()=>setShowLeaveModal(true)}>
              <Text style={{color:'#fff',fontWeight:'700',fontSize:12}}>Request</Text>
            </TouchableOpacity>
          </View>
          <View style={{flexDirection:'row',gap:10}}>
            {[
              {label:'Annual',total:leaveBalance.annual,used:leaveBalance.usedAnnual||0,color:'#3B82F6',icon:'palm-tree'},
              {label:'Sick',total:leaveBalance.sick,used:leaveBalance.usedSick||0,color:'#EF4444',icon:'hospital-box'},
              {label:'Pending',total:leaveBalance.pending||0,used:0,color:'#F59E0B',icon:'clock-alert',noProg:true},
            ].map(b=>{
              const rem = (b.total||0)-(b.used||0);
              const pct = b.total>0?Math.round((b.used/b.total)*100):0;
              return(
                <View key={b.label} style={{flex:1,backgroundColor:b.color+'10',borderRadius:14,padding:12,alignItems:'center',borderTopWidth:3,borderTopColor:b.color}}>
                  <MaterialCommunityIcons name={b.icon} size={20} color={b.color}/>
                  <Text style={{fontSize:22,fontWeight:'900',color:b.color,marginTop:6}}>{b.noProg?b.total:rem}</Text>
                  <Text style={{fontSize:10,color:'#6B7280',textAlign:'center',marginTop:2}}>{b.noProg?'awaiting':'days left'}</Text>
                  <Text style={{fontSize:10,color:b.color,fontWeight:'600',marginTop:2}}>{b.label}</Text>
                  {!b.noProg&&b.total>0&&<View style={{width:'100%',height:4,backgroundColor:'#E5E7EB',borderRadius:2,overflow:'hidden',marginTop:8}}>
                    <View style={{width:`${pct}%`,height:'100%',backgroundColor:b.color,borderRadius:2}}/>
                  </View>}
                </View>
              );
            })}
          </View>
        </Animated.View>

        {/* ── Attendance This Month ──────────────────────── */}
        <Animated.View style={[styles.section,{opacity:fadeAnim}]}>
          <Text style={styles.sectionTitle}>📊 Attendance This Month</Text>
          <View style={{flexDirection:'row',gap:10,marginTop:12}}>
            {[
              {label:'Present',val:myAttendance.present,color:'#10B981',icon:'check-circle'},
              {label:'Absent',val:myAttendance.absent,color:'#EF4444',icon:'close-circle'},
              {label:'Late',val:myAttendance.late,color:'#F59E0B',icon:'clock-alert'},
              {label:'Rate',val:`${myAttendance.rate}%`,color:'#3B82F6',icon:'chart-donut'},
            ].map(m=>(
              <View key={m.label} style={{flex:1,backgroundColor:'#F9FAFB',borderRadius:12,padding:10,alignItems:'center',borderBottomWidth:3,borderBottomColor:m.color}}>
                <MaterialCommunityIcons name={m.icon} size={18} color={m.color}/>
                <Text style={{fontSize:16,fontWeight:'900',color:m.color,marginTop:4}}>{m.val}</Text>
                <Text style={{fontSize:9,color:'#9CA3AF',marginTop:1}}>{m.label}</Text>
              </View>
            ))}
          </View>
          {myAttendance.monthlyTarget > 0 && (
            <View style={{marginTop:12}}>
              <View style={{flexDirection:'row',justifyContent:'space-between',marginBottom:4}}>
                <Text style={{fontSize:12,color:'#6B7280'}}>Monthly Target</Text>
                <Text style={{fontSize:12,fontWeight:'700',color:myAttendance.rate>=90?'#10B981':'#F59E0B'}}>{myAttendance.present}/{myAttendance.monthlyTarget} days</Text>
              </View>
              <View style={{height:8,backgroundColor:'#F1F5F9',borderRadius:4,overflow:'hidden'}}>
                <View style={{width:`${Math.min(myAttendance.present/myAttendance.monthlyTarget*100,100)}%`,height:'100%',
                  backgroundColor:myAttendance.rate>=90?'#10B981':'#F59E0B',borderRadius:4}}/>
              </View>
            </View>
          )}
        </Animated.View>

        {/* ── My Goals ──────────────────────────────────── */}
        {(personalGoals||[]).length > 0 && (
          <Animated.View style={[styles.section,{opacity:fadeAnim}]}>
            <View style={styles.sectionHeader}>
              <Text style={styles.sectionTitle}>🎯 My Goals</Text>
              <TouchableOpacity style={styles.seeAllButton} onPress={()=>setShowGoalModal(true)}>
                <Text style={styles.seeAllText}>+ Add</Text>
                <MaterialCommunityIcons name="chevron-right" size={16} color="#4a90e2"/>
              </TouchableOpacity>
            </View>
            {(personalGoals||[]).slice(0,3).map((g,i)=>{
              const catColor={Learning:'#8B5CF6',Work:'#3B82F6',Personal:'#10B981',Health:'#EF4444'}[g.category]||'#6B7280';
              const daysLeft = Math.ceil((new Date(g.dueDate)-new Date())/86400000);
              return(
                <View key={g.id||i} style={{marginBottom:12}}>
                  <View style={{flexDirection:'row',justifyContent:'space-between',alignItems:'center',marginBottom:4}}>
                    <Text style={{fontSize:13,fontWeight:'600',color:'#1F2937',flex:1}} numberOfLines={1}>{g.title}</Text>
                    <View style={{flexDirection:'row',alignItems:'center',gap:8}}>
                      <View style={{backgroundColor:catColor+'20',borderRadius:8,paddingHorizontal:7,paddingVertical:2}}>
                        <Text style={{fontSize:9,color:catColor,fontWeight:'700'}}>{g.category}</Text>
                      </View>
                      <Text style={{fontSize:11,fontWeight:'700',color:catColor}}>{g.progress}%</Text>
                    </View>
                  </View>
                  <View style={{height:7,backgroundColor:'#F1F5F9',borderRadius:4,overflow:'hidden',marginBottom:3}}>
                    <View style={{width:`${g.progress}%`,height:'100%',backgroundColor:catColor,borderRadius:4}}/>
                  </View>
                  <Text style={{fontSize:10,color: daysLeft<7?'#EF4444':'#9CA3AF'}}>
                    <Text>{daysLeft<0?'Overdue':daysLeft===0?'Due today':`${daysLeft}d left`} · Due {g.dueDate}</Text>
                  </Text>
                </View>
              );
            })}
          </Animated.View>
        )}

        {/* ── Training ──────────────────────────────────── */}
        {(trainingModules||[]).length > 0 && (
          <Animated.View style={[styles.section,{opacity:fadeAnim}]}>
            <View style={styles.sectionHeader}>
              <Text style={styles.sectionTitle}>📚 Training & Learning</Text>
              <TouchableOpacity style={styles.seeAllButton} onPress={()=>navigation.navigate('Training')}>
                <Text style={styles.seeAllText}>See All</Text>
                <MaterialCommunityIcons name="chevron-right" size={16} color="#4a90e2"/>
              </TouchableOpacity>
            </View>
            {(trainingModules||[]).map((m,i)=>{
              const sCfg={completed:{color:'#10B981',bg:'#ECFDF5',label:'✓ Done'},in_progress:{color:'#3B82F6',bg:'#EFF6FF',label:'In Progress'},not_started:{color:'#9CA3AF',bg:'#F9FAFB',label:'Not Started'}}[m.status]||{color:'#9CA3AF',bg:'#F9FAFB',label:m.status};
              return(
                <View key={m.id||i} style={{flexDirection:'row',alignItems:'center',paddingVertical:10,borderBottomWidth:i<(trainingModules||[]).length-1?1:0,borderBottomColor:'#F8FAFC',gap:10}}>
                  <View style={{width:36,height:36,borderRadius:18,backgroundColor:sCfg.color+'15',alignItems:'center',justifyContent:'center'}}>
                    <MaterialCommunityIcons name={m.status==='completed'?'check-circle':'book-open'} size={18} color={sCfg.color}/>
                  </View>
                  <View style={{flex:1}}>
                    <Text style={{fontSize:13,fontWeight:'600',color:'#1F2937'}}>{m.title}</Text>
                    <View style={{flexDirection:'row',gap:8,marginTop:3}}>
                      <View style={{backgroundColor:sCfg.bg,borderRadius:8,paddingHorizontal:7,paddingVertical:2}}>
                        <Text style={{fontSize:10,color:sCfg.color,fontWeight:'700'}}>{sCfg.label}</Text>
                      </View>
                      <Text style={{fontSize:10,color:'#9CA3AF',alignSelf:'center'}}>Due {m.dueDate}</Text>
                    </View>
                    {m.status!=='not_started'&&(
                      <View style={{height:4,backgroundColor:'#F1F5F9',borderRadius:2,overflow:'hidden',marginTop:6}}>
                        <View style={{width:`${m.progress}%`,height:'100%',backgroundColor:sCfg.color,borderRadius:2}}/>
                      </View>
                    )}
                  </View>
                  {m.status!=='completed'&&(
                    <TouchableOpacity style={{backgroundColor:sCfg.color,borderRadius:8,paddingHorizontal:12,paddingVertical:6}}
                      onPress={()=>navigation.navigate('Training',{moduleId:m.id})}>
                      <Text style={{color:'#fff',fontSize:11,fontWeight:'700'}}>{m.status==='in_progress'?'Resume':'Start'}</Text>
                    </TouchableOpacity>
                  )}
                </View>
              );
            })}
          </Animated.View>
        )}

        {/* ── Upcoming Schedule ─────────────────────────── */}
        {(upcomingEvents||[]).length > 0 && (
          <Animated.View style={[styles.section,{opacity:fadeAnim}]}>
            <View style={styles.sectionHeader}>
              <Text style={styles.sectionTitle}>📅 Upcoming Schedule</Text>
              <TouchableOpacity style={styles.seeAllButton} onPress={()=>navigation.navigate('Calendar')}>
                <Text style={styles.seeAllText}>Calendar</Text>
                <MaterialCommunityIcons name="chevron-right" size={16} color="#4a90e2"/>
              </TouchableOpacity>
            </View>
            {(upcomingEvents||[]).map((e,i)=>(
              <View key={e.id||i} style={{flexDirection:'row',alignItems:'center',paddingVertical:10,borderBottomWidth:i<(upcomingEvents||[]).length-1?1:0,borderBottomColor:'#F8FAFC',gap:10}}>
                <View style={{width:38,height:38,borderRadius:19,backgroundColor:e.color+'15',alignItems:'center',justifyContent:'center'}}>
                  <MaterialCommunityIcons name={e.icon} size={18} color={e.color}/>
                </View>
                <View style={{flex:1}}>
                  <Text style={{fontSize:13,fontWeight:'600',color:'#1F2937'}}>{e.title}</Text>
                  <Text style={{fontSize:11,color:e.date.startsWith('Today')?e.color:'#6B7280',fontWeight:e.date.startsWith('Today')?'700':'400',marginTop:2}}>{e.date}</Text>
                </View>
                {e.date.startsWith('Today')&&<View style={{backgroundColor:'#EFF6FF',borderRadius:8,paddingHorizontal:8,paddingVertical:3}}>
                  <Text style={{fontSize:10,color:'#3B82F6',fontWeight:'700'}}>TODAY</Text>
                </View>}
              </View>
            ))}
          </Animated.View>
        )}

        {/* ── Team Directory ─────────────────────────────── */}
        {(teamMembers||[]).length > 0 && (
          <Animated.View style={[styles.section,{opacity:fadeAnim}]}>
            <View style={styles.sectionHeader}>
              <Text style={styles.sectionTitle}>👥 My Team</Text>
              <TouchableOpacity style={styles.seeAllButton} onPress={()=>setShowTeamModal(true)}>
                <Text style={styles.seeAllText}>See All</Text>
                <MaterialCommunityIcons name="chevron-right" size={16} color="#4a90e2"/>
              </TouchableOpacity>
            </View>
            <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{gap:12}}>
              {(teamMembers||[]).map((m,i)=>{
                const statusColor={online:'#10B981',busy:'#EF4444',away:'#F59E0B',offline:'#9CA3AF'}[m.status]||'#9CA3AF';
                const src=m.avatar||`https://ui-avatars.com/api/?name=${encodeURIComponent(m.name)}&background=random&color=fff&size=100&bold=true`;
                return(
                  <TouchableOpacity key={m.id||i} style={{alignItems:'center',width:70}}>
                    <View style={{position:'relative',marginBottom:8}}>
                      <Image source={{uri:src}} style={{width:52,height:52,borderRadius:26,borderWidth:2,borderColor:statusColor}}/>
                      <View style={{position:'absolute',bottom:0,right:0,width:14,height:14,borderRadius:7,backgroundColor:statusColor,borderWidth:2,borderColor:'#fff'}}/>
                    </View>
                    <Text style={{fontSize:11,fontWeight:'600',color:'#1F2937',textAlign:'center'}} numberOfLines={1}>{m.name.split(' ')[0]}</Text>
                    <Text style={{fontSize:9,color:'#9CA3AF',textAlign:'center',marginTop:1}} numberOfLines={1}>{m.role.split(' ')[0]}</Text>
                  </TouchableOpacity>
                );
              })}
            </ScrollView>
          </Animated.View>
        )}

        {/* ── Benefits ──────────────────────────────────── */}
        {(benefits||[]).length > 0 && (
          <Animated.View style={[styles.section,{opacity:fadeAnim,marginBottom:32}]}>
            <Text style={styles.sectionTitle}>💎 My Benefits</Text>
            {(benefits||[]).map((b,i)=>(
              <View key={b.id||i} style={{flexDirection:'row',alignItems:'center',paddingVertical:10,borderBottomWidth:i<(benefits||[]).length-1?1:0,borderBottomColor:'#F8FAFC',gap:10}}>
                <View style={{width:36,height:36,borderRadius:18,backgroundColor:'#EFF6FF',alignItems:'center',justifyContent:'center'}}>
                  <MaterialCommunityIcons name={b.icon} size={18} color='#3B82F6'/>
                </View>
                <View style={{flex:1}}>
                  <Text style={{fontSize:13,fontWeight:'600',color:'#1F2937'}}>{b.label}</Text>
                  <Text style={{fontSize:11,color:'#9CA3AF',marginTop:1}}>{b.detail}</Text>
                </View>
                <View style={{backgroundColor:b.status==='Active'?'#ECFDF5':'#EFF6FF',borderRadius:8,paddingHorizontal:8,paddingVertical:3}}>
                  <Text style={{fontSize:10,fontWeight:'700',color:b.status==='Active'?'#059669':'#3B82F6'}}>{b.status}</Text>
                </View>
              </View>
            ))}
          </Animated.View>
        )}

      </ScrollView>

      {/* Notifications Modal */}
      <Modal
        visible={showNotifications}
        animationType="slide"
        transparent={true}
        onRequestClose={() => setShowNotifications(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Notifications</Text>
              <View style={styles.modalHeaderActions}>
                {(notifications||[]).filter(n => !n.read).length > 0 && (
                  <TouchableOpacity 
                    style={styles.markAllReadButton}
                    onPress={markAllNotificationsAsRead}
                  >
                    <Text style={styles.markAllReadText}>Mark all read</Text>
                  </TouchableOpacity>
                )}
                <TouchableOpacity onPress={() => setShowNotifications(false)}>
                  <MaterialCommunityIcons name="close" size={24} color="#6b7280" />
                </TouchableOpacity>
              </View>
            </View>
            
            <FlatList
              data={notifications}
              keyExtractor={(item) => item.id.toString()}
              renderItem={({ item }) => (
                <TouchableOpacity
                  style={[styles.notificationItem, !item.read && styles.unreadNotification]}
                  onPress={() => handleNotificationPress(item)}
                >
                  <MaterialCommunityIcons 
                    name={
                      item.type === 'task' ? 'clipboard-list' : 
                      item.type === 'meeting' ? 'calendar' : 
                      item.type === 'approval' ? 'check-circle' : 'bell'
                    } 
                    size={24} 
                    color="#4a90e2" 
                  />
                  <View style={styles.notificationContent}>
                    <Text style={styles.notificationTitle}>{item.title}</Text>
                    <Text style={styles.notificationMessage}>{item.message}</Text>
                    <Text style={styles.notificationTime}>{item.time}</Text>
                  </View>
                  {!item.read && <View style={styles.unreadDot} />}
                </TouchableOpacity>
              )}
              ListEmptyComponent={
                <View style={styles.emptyNotifications}>
                  <MaterialCommunityIcons name="bell-off" size={48} color="#d1d5db" />
                  <Text style={styles.emptyNotificationsText}>No notifications</Text>
                </View>
              }
            />
          </View>
        </View>
      </Modal>

      {/* Payslips Modal */}
      <Modal
        visible={showPayslipsModal}
        animationType="slide"
        transparent={true}
        onRequestClose={() => setShowPayslipsModal(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>My Payslips</Text>
              <View style={{ backgroundColor: '#8b5cf610', borderRadius: 8, paddingHorizontal: 8, paddingVertical: 3, marginLeft: 8 }}>
                <Text style={{ fontSize: 10, color: '#8b5cf6', fontWeight: '700' }}>PERSONAL</Text>
              </View>
              <TouchableOpacity onPress={() => setShowPayslipsModal(false)}>
                <MaterialCommunityIcons name="close" size={24} color="#6b7280" />
              </TouchableOpacity>
            </View>
            
            {/* Payroll Summary in Modal */}
            <View style={styles.payslipSummaryRow}>
              <View style={styles.payslipSummaryItem}>
                <Text style={styles.payslipSummaryLabel}>YTD Gross</Text>
                <Text style={styles.payslipSummaryValue}>{formatCurrency(payrollSummary.ytdGross)}</Text>
              </View>
              <View style={styles.payslipSummaryItem}>
                <Text style={styles.payslipSummaryLabel}>YTD Net</Text>
                <Text style={[styles.payslipSummaryValue, { color: '#10b981' }]}>{formatCurrency(payrollSummary.ytdNet)}</Text>
              </View>
              <View style={styles.payslipSummaryItem}>
                <Text style={styles.payslipSummaryLabel}>Tax Code</Text>
                <Text style={styles.payslipSummaryValue}>{payrollSummary.taxCode}</Text>
              </View>
            </View>

            <FlatList
              data={payrollSummary.payslips}
              keyExtractor={(item, idx) => item.id?.toString() || idx.toString()}
              renderItem={({ item }) => (
                <PayslipItem
                  payslip={item}
                  onPress={() => {
                    setSelectedPayslip(item);
                    setShowPayslipDetail(true);
                  }}
                />
              )}
              ListEmptyComponent={
                <View style={styles.emptyNotifications}>
                  <MaterialCommunityIcons name="file-document-outline" size={48} color="#d1d5db" />
                  <Text style={styles.emptyNotificationsText}>No payslips available yet</Text>
                  <Text style={{ fontSize: 13, color: '#9ca3af', marginTop: 8, textAlign: 'center' }}>
                    Payslips will appear here after your first pay run is processed
                  </Text>
                </View>
              }
            />
          </View>
        </View>
      </Modal>

      {/* Payslip Detail Modal */}
      <Modal
        visible={showPayslipDetail}
        animationType="slide"
        transparent={true}
        onRequestClose={() => setShowPayslipDetail(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Payslip Detail</Text>
              <TouchableOpacity onPress={() => setShowPayslipDetail(false)}>
                <MaterialCommunityIcons name="close" size={24} color="#6b7280" />
              </TouchableOpacity>
            </View>
            {selectedPayslip && (
              <ScrollView showsVerticalScrollIndicator={false}>
                <View style={styles.payslipDetailSection}>
                  <Text style={styles.payslipDetailPeriod}>
                    {formatPayPeriod(selectedPayslip.period || selectedPayslip.date)}
                  </Text>
                  <View style={styles.payslipDetailRow}>
                    <Text style={styles.payslipDetailLabel}>Employee</Text>
                    <Text style={styles.payslipDetailValue}>{selectedPayslip.employeeName || user?.name}</Text>
                  </View>
                  <View style={styles.payslipDetailRow}>
                    <Text style={styles.payslipDetailLabel}>Gross Pay</Text>
                    <Text style={styles.payslipDetailValue}>{formatCurrency(selectedPayslip.gross || selectedPayslip.grossPay || 0)}</Text>
                  </View>
                  <View style={styles.payslipDetailRow}>
                    <Text style={styles.payslipDetailLabel}>Income Tax</Text>
                    <Text style={[styles.payslipDetailValue, { color: '#ef4444' }]}>-{formatCurrency(selectedPayslip.tax || selectedPayslip.incomeTax || 0)}</Text>
                  </View>
                  <View style={styles.payslipDetailRow}>
                    <Text style={styles.payslipDetailLabel}>National Insurance</Text>
                    <Text style={[styles.payslipDetailValue, { color: '#ef4444' }]}>-{formatCurrency(selectedPayslip.ni || selectedPayslip.nationalInsurance || 0)}</Text>
                  </View>
                  <View style={styles.payslipDetailRow}>
                    <Text style={styles.payslipDetailLabel}>Pension</Text>
                    <Text style={[styles.payslipDetailValue, { color: '#8b5cf6' }]}>-{formatCurrency(selectedPayslip.employeePension || selectedPayslip.pension || 0)}</Text>
                  </View>
                  {(selectedPayslip.studentLoan || 0) > 0 && (
                    <View style={styles.payslipDetailRow}>
                      <Text style={styles.payslipDetailLabel}>Student Loan</Text>
                      <Text style={[styles.payslipDetailValue, { color: '#ef4444' }]}>-{formatCurrency(selectedPayslip.studentLoan || 0)}</Text>
                    </View>
                  )}
                  {(selectedPayslip.bonus || 0) > 0 && (
                    <View style={styles.payslipDetailRow}>
                      <Text style={styles.payslipDetailLabel}>Bonus</Text>
                      <Text style={[styles.payslipDetailValue, { color: '#10b981' }]}>+{formatCurrency(selectedPayslip.bonus || 0)}</Text>
                    </View>
                  )}
                  {(selectedPayslip.overtime || selectedPayslip.overtimePay || 0) > 0 && (
                    <View style={styles.payslipDetailRow}>
                      <Text style={styles.payslipDetailLabel}>Overtime</Text>
                      <Text style={[styles.payslipDetailValue, { color: '#10b981' }]}>+{formatCurrency(selectedPayslip.overtime || selectedPayslip.overtimePay || 0)}</Text>
                    </View>
                  )}
                  {(selectedPayslip.allowances || 0) > 0 && (
                    <View style={styles.payslipDetailRow}>
                      <Text style={styles.payslipDetailLabel}>Allowances</Text>
                      <Text style={[styles.payslipDetailValue, { color: '#10b981' }]}>+{formatCurrency(selectedPayslip.allowances || 0)}</Text>
                    </View>
                  )}
                  <View style={[styles.payslipDetailRow, styles.payslipNetRow]}>
                    <Text style={styles.payslipNetDetailLabel}>Net Pay</Text>
                    <Text style={styles.payslipNetDetailValue}>{formatCurrency(selectedPayslip.net || selectedPayslip.netPay || 0)}</Text>
                  </View>
                </View>

                {/* Export actions */}
                <View style={{ flexDirection: 'row', gap: 10, marginTop: 16, marginBottom: 20 }}>
                  <TouchableOpacity onPress={() => exportPayslipPDF(selectedPayslip)} disabled={payslipPdfLoading}
                    style={{ flex: 1, backgroundColor: '#8b5cf6', borderRadius: 12, paddingVertical: 13, alignItems: 'center', flexDirection: 'row', justifyContent: 'center', gap: 8 }}>
                    {payslipPdfLoading ? <ActivityIndicator size={14} color="#fff" /> : <MaterialCommunityIcons name="file-pdf-box" size={18} color="#fff" />}
                    <Text style={{ color: '#fff', fontWeight: '700', fontSize: 14 }}>Export PDF</Text>
                  </TouchableOpacity>
                  <TouchableOpacity onPress={() => printPayslip(selectedPayslip)}
                    style={{ flex: 1, backgroundColor: '#f1f5f9', borderRadius: 12, paddingVertical: 13, alignItems: 'center', flexDirection: 'row', justifyContent: 'center', gap: 8, borderWidth: 1, borderColor: '#e2e8f0' }}>
                    <MaterialCommunityIcons name="printer" size={18} color="#374151" />
                    <Text style={{ color: '#374151', fontWeight: '700', fontSize: 14 }}>Print</Text>
                  </TouchableOpacity>
                </View>
              </ScrollView>
            )}
          </View>
        </View>
      </Modal>


      {/* Full Payroll Details Modal */}
      <Modal visible={showPayrollFullModal} animationType="slide" transparent onRequestClose={() => setShowPayrollFullModal(false)}>
        <View style={styles.modalOverlay}>
          <View style={[styles.modalContent, { maxHeight: height * 0.85 }]}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>My Payroll</Text>
              <View style={{ backgroundColor: '#8b5cf610', borderRadius: 8, paddingHorizontal: 8, paddingVertical: 3, marginLeft: 8 }}>
                <Text style={{ fontSize: 10, color: '#8b5cf6', fontWeight: '700' }}>PERSONAL</Text>
              </View>
              <TouchableOpacity onPress={() => setShowPayrollFullModal(false)}>
                <MaterialCommunityIcons name="close" size={24} color="#6b7280" />
              </TouchableOpacity>
            </View>
            <ScrollView showsVerticalScrollIndicator={false}>
              {/* Confidential notice */}
              <View style={{ backgroundColor: '#faf5ff', borderRadius: 10, padding: 10, marginBottom: 12, flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                <MaterialCommunityIcons name="shield-lock" size={16} color="#8b5cf6" />
                <Text style={{ fontSize: 11, color: '#7c3aed', flex: 1 }}>This information is personal and confidential. Only you can see your payroll details.</Text>
              </View>
              {/* Salary */}
              <View style={{ backgroundColor: '#f8fafc', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                <Text style={{ fontSize: 13, fontWeight: '700', color: '#1a365d', marginBottom: 10 }}>Salary Information</Text>
                {[
                  ['Annual Salary', payrollExtended.salary > 0 ? `£${payrollExtended.salary.toLocaleString()}` : '—'],
                  ['Monthly Gross', payrollExtended.salary > 0 ? `£${(payrollExtended.salary / 12).toFixed(2)}` : '—'],
                  ['Contract', payrollExtended.contractType],
                  ['Hours/Week', `${payrollExtended.hoursPerWeek}h`],
                  ['Pay Frequency', payrollExtended.payFrequency],
                  ['Payment Method', payrollExtended.paymentMethod],
                ].map(([l, v], i) => (
                  <View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 6, borderBottomWidth: 1, borderBottomColor: '#f1f5f9' }}>
                    <Text style={{ fontSize: 13, color: '#6b7280' }}>{l}</Text>
                    <Text style={{ fontSize: 13, fontWeight: '600', color: '#1f2937' }}>{v}</Text>
                  </View>
                ))}
              </View>

              {/* Extras */}
              {(payrollExtended.bonus > 0 || payrollExtended.overtime > 0 || payrollExtended.allowances > 0 || payrollExtended.commission > 0) && (
                <View style={{ backgroundColor: '#f0fdf4', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                  <Text style={{ fontSize: 13, fontWeight: '700', color: '#059669', marginBottom: 10 }}>Additional Earnings</Text>
                  {[
                    ['Bonus', payrollExtended.bonus],
                    ['Overtime', payrollExtended.overtime],
                    ['Allowances', payrollExtended.allowances],
                    ['Commission', payrollExtended.commission],
                  ].filter(([, v]) => v > 0).map(([l, v], i) => (
                    <View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 6 }}>
                      <Text style={{ fontSize: 13, color: '#374151' }}>{l}</Text>
                      <Text style={{ fontSize: 13, fontWeight: '700', color: '#10b981' }}>+£{v.toLocaleString()}</Text>
                    </View>
                  ))}
                </View>
              )}

              {/* Tax & Pension */}
              <View style={{ backgroundColor: '#f8fafc', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                <Text style={{ fontSize: 13, fontWeight: '700', color: '#1a365d', marginBottom: 10 }}>Tax & Pension</Text>
                {[
                  ['Tax Code', payrollSummary.taxCode],
                  ['NI Category', payrollSummary.niCategory],
                  ['Pension Scheme', payrollExtended.pensionScheme || 'Workplace Pension'],
                  ['Employee Rate', `${payrollExtended.pensionContribRate}%`],
                  ['Employer Rate', `${payrollExtended.employerPensionRate}%`],
                  ...(payrollExtended.studentLoanPlan ? [['Student Loan', `Plan ${payrollExtended.studentLoanPlan}`]] : []),
                ].map(([l, v], i) => (
                  <View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 6, borderBottomWidth: 1, borderBottomColor: '#f1f5f9' }}>
                    <Text style={{ fontSize: 13, color: '#6b7280' }}>{l}</Text>
                    <Text style={{ fontSize: 13, fontWeight: '600', color: '#1f2937' }}>{v}</Text>
                  </View>
                ))}
              </View>

              {/* Bank Details */}
              {payrollExtended.bankName ? (
                <View style={{ backgroundColor: '#eff6ff', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                  <Text style={{ fontSize: 13, fontWeight: '700', color: '#1e40af', marginBottom: 10 }}>Payment Details</Text>
                  {[
                    ['Bank', payrollExtended.bankName],
                    ['Account', payrollExtended.bankAccount ? '****' + payrollExtended.bankAccount.slice(-4) : '—'],
                    ['Sort Code', payrollExtended.bankSortCode || '—'],
                  ].map(([l, v], i) => (
                    <View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 6 }}>
                      <Text style={{ fontSize: 13, color: '#3b82f6' }}>{l}</Text>
                      <Text style={{ fontSize: 13, fontWeight: '600', color: '#1e40af' }}>{v}</Text>
                    </View>
                  ))}
                </View>
              ) : null}

              {/* YTD Summary */}
              <View style={{ backgroundColor: '#faf5ff', borderRadius: 12, padding: 14, marginBottom: 12 }}>
                <Text style={{ fontSize: 13, fontWeight: '700', color: '#7c3aed', marginBottom: 10 }}>Year-to-Date Summary</Text>
                {[
                  ['Gross Pay', payrollSummary.ytdGross, '#1f2937'],
                  ['Income Tax', payrollSummary.ytdTax, '#ef4444'],
                  ['National Insurance', payrollSummary.ytdNI, '#f59e0b'],
                  ['Pension', payrollSummary.ytdPension, '#8b5cf6'],
                  ['Net Pay', payrollSummary.ytdNet, '#10b981'],
                ].map(([l, v, color], i) => (
                  <View key={i} style={{ flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 6, borderBottomWidth: i < 4 ? 1 : 0, borderBottomColor: '#f3e8ff' }}>
                    <Text style={{ fontSize: 13, color: '#6b7280' }}>{l}</Text>
                    <Text style={{ fontSize: 13, fontWeight: i === 4 ? '800' : '600', color }}>£{(v || 0).toFixed(2)}</Text>
                  </View>
                ))}
              </View>

              {/* Export buttons */}
              <View style={{ flexDirection: 'row', gap: 10, marginBottom: 20 }}>
                <TouchableOpacity onPress={() => { setShowPayrollFullModal(false); setShowPayslipsModal(true); }}
                  style={{ flex: 1, backgroundColor: '#8b5cf6', borderRadius: 12, paddingVertical: 13, alignItems: 'center', flexDirection: 'row', justifyContent: 'center', gap: 8 }}>
                  <MaterialCommunityIcons name="file-document-multiple" size={18} color="#fff" />
                  <Text style={{ color: '#fff', fontWeight: '700' }}>View Payslips</Text>
                </TouchableOpacity>
                <TouchableOpacity onPress={exportP60}
                  style={{ flex: 1, backgroundColor: '#1a365d', borderRadius: 12, paddingVertical: 13, alignItems: 'center', flexDirection: 'row', justifyContent: 'center', gap: 8 }}>
                  <MaterialCommunityIcons name="file-certificate" size={18} color="#fff" />
                  <Text style={{ color: '#fff', fontWeight: '700' }}>Export P60</Text>
                </TouchableOpacity>
              </View>
            </ScrollView>
          </View>
        </View>
      </Modal>

      {/* Profile Modal */}
      <Modal
        visible={showProfile}
        animationType="slide"
        transparent={true}
        onRequestClose={() => setShowProfile(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <View style={styles.modalHeader}>
              <Text style={styles.modalTitle}>Profile</Text>
              <TouchableOpacity onPress={() => setShowProfile(false)}>
                <MaterialCommunityIcons name="close" size={24} color="#6b7280" />
              </TouchableOpacity>
            </View>
            
            <View style={styles.profileContent}>
              <Image 
                source={{ uri: user?.avatar || 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face' }}
                style={styles.profileAvatar}
              />
              <Text style={styles.profileName}>{user?.name || user?.full_name || 'Employee'}</Text>
              <Text style={styles.profileEmail}>{user?.email}</Text>
              <Text style={styles.profileRole}>{user?.role?.name || user?.userType || 'Employee'}</Text>
              <Text style={styles.profileCompany}>{user?.company?.name || 'JobEng Construction'}</Text>
              
              <View style={styles.profileStats}>
                <View style={styles.profileStat}>
                  <Text style={styles.profileStatValue}>{(tasks||[]).length}</Text>
                  <Text style={styles.profileStatLabel}>Total Tasks</Text>
                </View>
                <View style={styles.profileStat}>
                  <Text style={styles.profileStatValue}>
                    {(tasks||[]).filter(t => t.status === 'completed').length}
                  </Text>
                  <Text style={styles.profileStatLabel}>Completed</Text>
                </View>
                <View style={styles.profileStat}>
                  <Text style={styles.profileStatValue}>
                    {(projects||[]).filter(p => p.status === 'active').length}
                  </Text>
                  <Text style={styles.profileStatLabel}>Active Projects</Text>
                </View>
              </View>
              
              <View style={styles.profileActions}>
                <TouchableOpacity 
                  style={styles.profileButton}
                  onPress={() => {
                    setShowProfile(false);
                    navigation.navigate('EditProfile');
                  }}
                >
                  <MaterialCommunityIcons name="account-edit" size={20} color="#4a90e2" />
                  <Text style={styles.profileButtonText}>Edit Profile</Text>
                </TouchableOpacity>
                
                <TouchableOpacity 
                  style={styles.profileButton}
                  onPress={() => {
                    setShowProfile(false);
                    navigation.navigate('Settings');
                  }}
                >
                  <MaterialCommunityIcons name="cog" size={20} color="#4a90e2" />
                  <Text style={styles.profileButtonText}>Settings</Text>
                </TouchableOpacity>
                
                <TouchableOpacity 
                  style={[styles.profileButton, styles.logoutButton]}
                  onPress={() => {
                    setShowProfile(false);
                    handleLogout();
                  }}
                >
                  <MaterialCommunityIcons name="logout" size={20} color="#ef4444" />
                  <Text style={[styles.profileButtonText, styles.logoutButtonText]}>Logout</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </View>
      </Modal>

      {/* Leave Request Modal */}
      <Modal visible={showLeaveModal} transparent animationType="slide" onRequestClose={()=>setShowLeaveModal(false)}>
        <View style={{flex:1,backgroundColor:'rgba(0,0,0,0.5)',justifyContent:'flex-end'}}>
          <View style={{backgroundColor:'#fff',borderTopLeftRadius:24,borderTopRightRadius:24,padding:22,paddingBottom:Platform.OS==='ios'?40:24}}>
            <Text style={{fontSize:18,fontWeight:'bold',color:'#1f2937',marginBottom:16}}>Request Leave</Text>
            <Text style={{fontSize:12,fontWeight:'800',color:'#9CA3AF',textTransform:'uppercase',marginBottom:8}}>LEAVE TYPE</Text>
            <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={{gap:8,marginBottom:16}}>
              {['Annual','Sick','Unpaid','Maternity','Paternity','Compassionate'].map(t=>(
                <TouchableOpacity key={t} onPress={()=>setLeaveType(t)}
                  style={{paddingHorizontal:14,paddingVertical:9,borderRadius:12,backgroundColor:leaveType===t?'#3b82f6':'#f3f4f6',borderWidth:1,borderColor:leaveType===t?'#3b82f6':'#e5e7eb'}}>
                  <Text style={{fontSize:13,color:leaveType===t?'#fff':'#6b7280',fontWeight:'600'}}>{t}</Text>
                </TouchableOpacity>
              ))}
            </ScrollView>
            <Text style={{fontSize:12,fontWeight:'800',color:'#9CA3AF',textTransform:'uppercase',marginBottom:8}}>NUMBER OF DAYS</Text>
            <TextInput style={{backgroundColor:'#f9fafb',borderWidth:1.5,borderColor:'#e5e7eb',borderRadius:12,paddingHorizontal:14,paddingVertical:11,fontSize:16,color:'#1f2937',marginBottom:12}}
              value={leaveDays} onChangeText={setLeaveDays} keyboardType="number-pad" placeholder="e.g. 3" placeholderTextColor="#d1d5db"/>
            <Text style={{fontSize:12,fontWeight:'800',color:'#9CA3AF',textTransform:'uppercase',marginBottom:8}}>REASON (OPTIONAL)</Text>
            <TextInput style={{backgroundColor:'#f9fafb',borderWidth:1.5,borderColor:'#e5e7eb',borderRadius:12,paddingHorizontal:14,paddingVertical:11,fontSize:14,color:'#1f2937',marginBottom:20,minHeight:70,textAlignVertical:'top'}}
              value={leaveNote} onChangeText={setLeaveNote} placeholder="Reason for leave…" multiline placeholderTextColor="#d1d5db"/>
            <View style={{flexDirection:'row',gap:10}}>
              <TouchableOpacity style={{flex:1,backgroundColor:'#f1f5f9',borderRadius:12,padding:14,alignItems:'center'}} onPress={()=>setShowLeaveModal(false)}>
                <Text style={{color:'#6b7280',fontWeight:'700'}}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity style={{flex:1,backgroundColor:'#3b82f6',borderRadius:12,padding:14,alignItems:'center',flexDirection:'row',justifyContent:'center',gap:6}} onPress={submitLeaveRequest}>
                <MaterialCommunityIcons name="calendar-check" size={16} color="#fff"/>
                <Text style={{color:'#fff',fontWeight:'700'}}>Submit Request</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Add Goal Modal */}
      <Modal visible={showGoalModal} transparent animationType="slide" onRequestClose={()=>setShowGoalModal(false)}>
        <View style={{flex:1,backgroundColor:'rgba(0,0,0,0.5)',justifyContent:'flex-end'}}>
          <View style={{backgroundColor:'#fff',borderTopLeftRadius:24,borderTopRightRadius:24,padding:22,paddingBottom:Platform.OS==='ios'?40:24}}>
            <Text style={{fontSize:18,fontWeight:'bold',color:'#1f2937',marginBottom:16}}>Add Goal</Text>
            {[{label:'GOAL TITLE',value:newGoalTitle,setter:setNewGoalTitle,ph:'e.g. Complete AWS Certification'},{label:'TARGET / DEADLINE',value:newGoalTarget,setter:setNewGoalTarget,ph:'YYYY-MM-DD'}].map(f=>(
              <View key={f.label} style={{marginBottom:14}}>
                <Text style={{fontSize:12,fontWeight:'800',color:'#9CA3AF',textTransform:'uppercase',marginBottom:8}}>{f.label}</Text>
                <TextInput style={{backgroundColor:'#f9fafb',borderWidth:1.5,borderColor:'#e5e7eb',borderRadius:12,paddingHorizontal:14,paddingVertical:11,fontSize:14,color:'#1f2937'}}
                  value={f.value} onChangeText={f.setter} placeholder={f.ph} placeholderTextColor="#d1d5db"/>
              </View>
            ))}
            <View style={{flexDirection:'row',gap:10}}>
              <TouchableOpacity style={{flex:1,backgroundColor:'#f1f5f9',borderRadius:12,padding:14,alignItems:'center'}} onPress={()=>setShowGoalModal(false)}>
                <Text style={{color:'#6b7280',fontWeight:'700'}}>Cancel</Text>
              </TouchableOpacity>
              <TouchableOpacity style={{flex:1,backgroundColor:'#8b5cf6',borderRadius:12,padding:14,alignItems:'center'}}
                onPress={async()=>{
                  if(!newGoalTitle.trim()){Alert.alert('Required','Enter a goal title.');return;}
                  const g={id:`g_${Date.now()}`,title:newGoalTitle.trim(),progress:0,dueDate:newGoalTarget||'No deadline',category:'Work'};
                  await persistGoal([...personalGoals,g]);
                  setNewGoalTitle('');setNewGoalTarget('');setShowGoalModal(false);
                }}>
                <Text style={{color:'#fff',fontWeight:'700'}}>Add Goal</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      {/* Team Directory Modal */}
      <Modal visible={showTeamModal} animationType="slide" transparent={false} onRequestClose={()=>setShowTeamModal(false)}>
        <SafeAreaView style={{flex:1,backgroundColor:'#f8fafc'}}>
          <View style={{flexDirection:'row',alignItems:'center',justifyContent:'space-between',padding:16,backgroundColor:'#fff',borderBottomWidth:1,borderBottomColor:'#e5e7eb'}}>
            <Text style={{fontSize:18,fontWeight:'bold',color:'#1f2937'}}>My Team</Text>
            <TouchableOpacity onPress={()=>setShowTeamModal(false)}>
              <MaterialCommunityIcons name="close" size={24} color="#6b7280"/>
            </TouchableOpacity>
          </View>
          <FlatList data={teamMembers} keyExtractor={m=>m.id} contentContainerStyle={{padding:16}}
            renderItem={({item:m})=>{
              const statusColor={online:'#10B981',busy:'#EF4444',away:'#F59E0B',offline:'#9CA3AF'}[m.status]||'#9CA3AF';
              const src=m.avatar||`https://ui-avatars.com/api/?name=${encodeURIComponent(m.name)}&background=random&color=fff&size=100&bold=true`;
              return(
                <View style={{flexDirection:'row',alignItems:'center',backgroundColor:'#fff',borderRadius:14,padding:14,marginBottom:10,shadowColor:'#000',shadowOffset:{width:0,height:1},shadowOpacity:0.05,shadowRadius:3,elevation:2}}>
                  <View style={{position:'relative',marginRight:14}}>
                    <Image source={{uri:src}} style={{width:52,height:52,borderRadius:26}}/>
                    <View style={{position:'absolute',bottom:0,right:0,width:14,height:14,borderRadius:7,backgroundColor:statusColor,borderWidth:2,borderColor:'#fff'}}/>
                  </View>
                  <View style={{flex:1}}>
                    <Text style={{fontSize:15,fontWeight:'700',color:'#1f2937'}}>{m.name}</Text>
                    <Text style={{fontSize:12,color:'#6b7280',marginTop:2}}>{m.role}</Text>
                    <View style={{backgroundColor:statusColor+'20',borderRadius:8,paddingHorizontal:8,paddingVertical:2,alignSelf:'flex-start',marginTop:5}}>
                      <Text style={{fontSize:10,fontWeight:'700',color:statusColor}}>{m.status.charAt(0).toUpperCase()+m.status.slice(1)}</Text>
                    </View>
                  </View>
                  <View style={{gap:8}}>
                    {m.email&&<TouchableOpacity style={{backgroundColor:'#EFF6FF',borderRadius:8,padding:7}} onPress={()=>Linking.openURL(`mailto:${m.email}`)}>
                      <MaterialCommunityIcons name="email-outline" size={16} color="#3b82f6"/>
                    </TouchableOpacity>}
                    <TouchableOpacity style={{backgroundColor:'#ECFDF5',borderRadius:8,padding:7}} onPress={()=>navigation.navigate('BusinessVideoConferenceScreen',{participantName:m.name})}>
                      <MaterialCommunityIcons name="video-outline" size={16} color="#10b981"/>
                    </TouchableOpacity>
                  </View>
                </View>
              );
            }}
          />
        </SafeAreaView>
      </Modal>

      {/* Announcements Modal */}
      <Modal visible={showAnnounceModal} animationType="slide" transparent={false} onRequestClose={()=>setShowAnnounceModal(false)}>
        <SafeAreaView style={{flex:1,backgroundColor:'#f8fafc'}}>
          <View style={{flexDirection:'row',alignItems:'center',justifyContent:'space-between',padding:16,backgroundColor:'#fff',borderBottomWidth:1,borderBottomColor:'#e5e7eb'}}>
            <Text style={{fontSize:18,fontWeight:'bold',color:'#1f2937'}}>Announcements</Text>
            <TouchableOpacity onPress={()=>setShowAnnounceModal(false)}>
              <MaterialCommunityIcons name="close" size={24} color="#6b7280"/>
            </TouchableOpacity>
          </View>
          <FlatList data={announcements} keyExtractor={a=>a.id} contentContainerStyle={{padding:16}}
            renderItem={({item:a})=>{
              const colorMap={high:'#EF4444',medium:'#F59E0B',low:'#10B981'};
              const iconMap={meeting:'calendar-clock',info:'information',hr:'account-heart'};
              const color=colorMap[a.priority]||'#3B82F6';
              return(
                <View style={{backgroundColor:'#fff',borderRadius:14,padding:16,marginBottom:10,borderLeftWidth:4,borderLeftColor:color,shadowColor:'#000',shadowOffset:{width:0,height:1},shadowOpacity:0.05,shadowRadius:3,elevation:2}}>
                  <View style={{flexDirection:'row',alignItems:'flex-start',gap:10}}>
                    <View style={{width:36,height:36,borderRadius:18,backgroundColor:color+'15',alignItems:'center',justifyContent:'center',flexShrink:0}}>
                      <MaterialCommunityIcons name={iconMap[a.type]||'bell'} size={18} color={color}/>
                    </View>
                    <View style={{flex:1}}>
                      <Text style={{fontSize:15,fontWeight:'700',color:'#1f2937'}}>{a.title}</Text>
                      <Text style={{fontSize:13,color:'#6b7280',marginTop:4,lineHeight:19}}>{a.body}</Text>
                      <View style={{flexDirection:'row',alignItems:'center',gap:8,marginTop:8}}>
                        <Text style={{fontSize:11,color:'#9ca3af'}}>{a.time}</Text>
                        {a.priority==='high'&&<View style={{backgroundColor:'#FEF2F2',borderRadius:8,paddingHorizontal:8,paddingVertical:2}}>
                          <Text style={{fontSize:10,fontWeight:'700',color:'#EF4444'}}>URGENT</Text>
                        </View>}
                      </View>
                    </View>
                  </View>
                </View>
              );
            }}
          />
        </SafeAreaView>
      </Modal>

    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f8fafc',
  },
  header: {
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 24,
  },
  headerTop: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
  },
  userInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  avatar: {
    width: 60,
    height: 60,
    borderRadius: 30,
    marginRight: 16,
  },
  userDetails: {
    flex: 1,
  },
  userName: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 4,
  },
  userRole: {
    fontSize: 14,
    color: '#cbd5e1',
    marginBottom: 2,
  },
  companyName: {
    fontSize: 12,
    color: '#94a3b8',
  },
  headerActions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerButton: {
    marginLeft: 16,
    position: 'relative',
  },
  notificationBadge: {
    position: 'absolute',
    top: -8,
    right: -8,
    backgroundColor: '#ef4444',
    borderRadius: 10,
    minWidth: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  notificationBadgeText: {
    color: '#ffffff',
    fontSize: 12,
    fontWeight: 'bold',
  },
  timeInfo: {
    alignItems: 'center',
  },
  currentTime: {
    fontSize: 32,
    fontWeight: 'bold',
    color: '#ffffff',
    marginBottom: 4,
  },
  currentDate: {
    fontSize: 14,
    color: '#cbd5e1',
  },
  content: {
    flex: 1,
    paddingHorizontal: 20,
  },
  checkInSection: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 20,
    marginTop: 20,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  checkInButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 12,
    paddingVertical: 16,
    marginBottom: 20,
  },
  checkInButtonActive: {
    backgroundColor: '#10b981',
  },
  checkOutButton: {
    backgroundColor: '#ef4444',
  },
  checkInButtonText: {
    color: '#ffffff',
    fontSize: 18,
    fontWeight: '600',
    marginLeft: 8,
  },
  workHoursInfo: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  workHourItem: {
    alignItems: 'center',
  },
  workHourLabel: {
    fontSize: 12,
    color: '#6b7280',
    marginBottom: 4,
  },
  workHourValue: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1f2937',
  },
  statsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24,
  },
  statCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
    flex: 1,
    marginHorizontal: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  statValue: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1f2937',
    marginTop: 8,
    marginBottom: 4,
  },
  statLabel: {
    fontSize: 12,
    color: '#6b7280',
    textAlign: 'center',
  },
  quickActions: {
    marginBottom: 24,
  },
  sectionTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 16,
  },
  actionGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  actionCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    alignItems: 'center',
    width: (width - 80) / 3,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  actionIcon: {
    width: 48,
    height: 48,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 8,
  },
  actionText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#1f2937',
    textAlign: 'center',
  },
  section: {
    marginBottom: 24,
  },
  sectionHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 16,
  },
  seeAllButton: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  seeAllText: {
    fontSize: 14,
    color: '#4a90e2',
    fontWeight: '500',
    marginRight: 4,
  },
  taskCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  taskHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  taskTitleContainer: {
    flex: 1,
    marginRight: 12,
  },
  taskTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: 4,
  },
  taskProject: {
    fontSize: 14,
    color: '#6b7280',
  },
  priorityBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
  },
  priorityText: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  taskProgress: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  progressBar: {
    flex: 1,
    height: 6,
    backgroundColor: '#e5e7eb',
    borderRadius: 3,
    marginRight: 12,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#4a90e2',
    borderRadius: 3,
  },
  progressText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#6b7280',
  },
  taskFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  taskStatus: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  statusText: {
    fontSize: 12,
    fontWeight: '500',
    marginLeft: 4,
  },
  taskMeta: {
    alignItems: 'flex-end',
  },
  dueDate: {
    fontSize: 12,
    marginBottom: 2,
  },
  hoursText: {
    fontSize: 11,
    color: '#6b7280',
  },
  projectCard: {
    backgroundColor: '#ffffff',
    borderRadius: 12,
    padding: 16,
    marginBottom: 12,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  projectHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 8,
  },
  projectName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#1f2937',
    flex: 1,
    marginRight: 12,
  },
  statusBadge: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 6,
  },
  statusBadgeText: {
    fontSize: 10,
    fontWeight: 'bold',
    color: '#ffffff',
  },
  projectRole: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 12,
  },
  projectProgress: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 12,
  },
  projectFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  projectInfo: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  projectInfoText: {
    fontSize: 12,
    color: '#6b7280',
    marginLeft: 4,
  },
  projectBudget: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  budgetText: {
    fontSize: 12,
    color: '#6b7280',
    marginLeft: 4,
  },
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'flex-end',
  },
  modalContent: {
    backgroundColor: '#ffffff',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    maxHeight: '80%',
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 20,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e7eb',
  },
  modalHeaderActions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1f2937',
  },
  markAllReadButton: {
    marginRight: 16,
  },
  markAllReadText: {
    fontSize: 14,
    color: '#4a90e2',
    fontWeight: '500',
  },
  notificationItem: {
    flexDirection: 'row',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#f3f4f6',
    position: 'relative',
  },
  unreadNotification: {
    backgroundColor: '#f0f9ff',
  },
  unreadDot: {
    position: 'absolute',
    top: 16,
    right: 16,
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: '#4a90e2',
  },
  notificationContent: {
    flex: 1,
    marginLeft: 12,
  },
  notificationTitle: {
    fontSize: 16,
    fontWeight: '500',
    color: '#1f2937',
    marginBottom: 4,
  },
  notificationMessage: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 4,
  },
  notificationTime: {
    fontSize: 12,
    color: '#9ca3af',
  },
  emptyNotifications: {
    padding: 40,
    alignItems: 'center',
  },
  emptyNotificationsText: {
    fontSize: 16,
    color: '#6b7280',
    marginTop: 16,
  },
  profileContent: {
    padding: 20,
    alignItems: 'center',
  },
  profileAvatar: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 16,
  },
  profileName: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 8,
  },
  profileEmail: {
    fontSize: 16,
    color: '#6b7280',
    marginBottom: 4,
  },
  profileRole: {
    fontSize: 14,
    color: '#4a90e2',
    marginBottom: 4,
  },
  profileCompany: {
    fontSize: 14,
    color: '#6b7280',
    marginBottom: 24,
  },
  profileStats: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    marginBottom: 24,
    paddingHorizontal: 20,
  },
  profileStat: {
    alignItems: 'center',
  },
  profileStatValue: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#1f2937',
    marginBottom: 4,
  },
  profileStatLabel: {
    fontSize: 12,
    color: '#6b7280',
  },
  profileActions: {
    width: '100%',
  },
  profileButton: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8fafc',
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    marginBottom: 12,
  },
  profileButtonText: {
    fontSize: 16,
    fontWeight: '500',
    color: '#4a90e2',
    marginLeft: 8,
  },
  logoutButton: {
    backgroundColor: '#fef2f2',
  },
  logoutButtonText: {
    color: '#ef4444',
  },
  // ─── Payroll Summary Card ───────────────────────────────────────────────
  payrollCard: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: 16,
    marginBottom: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
    borderLeftWidth: 4,
    borderLeftColor: '#8b5cf6',
  },
  payrollCardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 14,
  },
  payrollCardTitleRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  payrollCardTitle: {
    fontSize: 17,
    fontWeight: '700',
    color: '#1f2937',
    marginLeft: 8,
  },
  payrollViewAllBtn: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  payrollViewAllText: {
    fontSize: 13,
    color: '#8b5cf6',
    fontWeight: '500',
  },
  payrollCardBody: {},
  payrollMainStats: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginBottom: 14,
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#f3f4f6',
  },
  payrollMainStat: {
    alignItems: 'center',
    flex: 1,
  },
  payrollDivider: {
    width: 1,
    height: 50,
    backgroundColor: '#e5e7eb',
  },
  payrollMainLabel: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 4,
    textAlign: 'center',
  },
  payrollMainValue: {
    fontSize: 20,
    fontWeight: '800',
    color: '#1f2937',
    textAlign: 'center',
  },
  payrollMainSubtext: {
    fontSize: 11,
    color: '#9ca3af',
    marginTop: 2,
    textAlign: 'center',
  },
  ytdSection: {},
  ytdTitle: {
    fontSize: 13,
    fontWeight: '600',
    color: '#374151',
    marginBottom: 10,
  },
  ytdGrid: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  ytdItem: {
    alignItems: 'center',
    flex: 1,
  },
  ytdLabel: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 2,
  },
  ytdValue: {
    fontSize: 14,
    fontWeight: '700',
  },
  ytdNetRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f0fdf4',
    padding: 10,
    borderRadius: 8,
  },
  ytdNetLabel: {
    fontSize: 14,
    fontWeight: '600',
    color: '#166534',
  },
  ytdNetValue: {
    fontSize: 16,
    fontWeight: '800',
    color: '#166534',
  },
  // ─── Payslip items ──────────────────────────────────────────────────────
  payslipItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#f3f4f6',
  },
  payslipIcon: {
    width: 40,
    height: 40,
    borderRadius: 8,
    backgroundColor: '#f3f0ff',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  payslipInfo: {
    flex: 1,
  },
  payslipPeriod: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1f2937',
    marginBottom: 2,
  },
  payslipGross: {
    fontSize: 12,
    color: '#6b7280',
  },
  payslipRight: {
    alignItems: 'flex-end',
    marginRight: 8,
  },
  payslipNet: {
    fontSize: 16,
    fontWeight: '700',
    color: '#10b981',
  },
  payslipNetLabel: {
    fontSize: 11,
    color: '#6b7280',
  },
  payslipSummaryRow: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: '#f8fafc',
    padding: 12,
    marginBottom: 8,
    borderRadius: 8,
  },
  payslipSummaryItem: {
    alignItems: 'center',
  },
  payslipSummaryLabel: {
    fontSize: 11,
    color: '#6b7280',
    marginBottom: 2,
  },
  payslipSummaryValue: {
    fontSize: 14,
    fontWeight: '700',
    color: '#1f2937',
  },
  payslipDetailSection: {
    padding: 16,
  },
  payslipDetailPeriod: {
    fontSize: 18,
    fontWeight: '700',
    color: '#1f2937',
    marginBottom: 16,
    textAlign: 'center',
  },
  payslipDetailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#f3f4f6',
  },
  payslipDetailLabel: {
    fontSize: 14,
    color: '#6b7280',
  },
  payslipDetailValue: {
    fontSize: 14,
    fontWeight: '600',
    color: '#1f2937',
  },
  payslipNetRow: {
    backgroundColor: '#f0fdf4',
    borderRadius: 8,
    borderBottomWidth: 0,
    padding: 12,
    marginTop: 8,
  },
  payslipNetDetailLabel: {
    fontSize: 16,
    fontWeight: '700',
    color: '#166534',
  },
  payslipNetDetailValue: {
    fontSize: 20,
    fontWeight: '800',
    color: '#166534',
  },
});